import { getAuth } from "firebase/auth";
import { getKycCreationTime } from "../../helpers/kycCreationTime";
import { isEntityKycCustomer } from "../../../../shared/kycAuthentication";
import React, { useContext, useEffect, useMemo, useState, useRef } from "react";

import "dayjs/locale/en-gb";

import {
  collection,
  documentId,
  orderBy,
  query,
  onSnapshot,
  where,
  Unsubscribe,
  QueryDocumentSnapshot,
  DocumentReference,
  Timestamp,
  setDoc,
  deleteField,
  arrayUnion,
  getDocs,
} from "firebase/firestore";


import {

  useIntl,
} from "react-intl";

import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { ConfigContext, MyUserDataContext } from "../../contexts";
import { httpsCallable } from "firebase/functions";
import {
  Group,
  Modal,
  TextInput,
  Text,
  Button,
  Space,
  Paper,
  Title,
  Image,
  SimpleGrid,
  ThemeIcon,
  Grid,
  Center,
  Stack,
  Alert,
  Box,
  Select,
  ActionIcon,
  Loader,
  LoadingOverlay,
  Collapse,
  Divider,
  Badge,
  Table,
  Tooltip,
  Card,
  Accordion,
} from "@mantine/core";
import { useForm } from "@mantine/form";



import {
  IconBuildingBank,
  IconWallet,
  IconShoppingCart,
  IconUsers,
  IconGitPullRequestClosed,
  IconTrademark,
  IconPodium,
  IconPhone,
  IconSchool,
  IconArrowLeft,
  IconX,
  IconSearch,
  IconRefresh,
  IconListDetails,
  IconTrash,
  IconUserCheck, IconCrown, IconCoins, IconUserShield,
  IconChevronUp,
  IconFileText,
  IconExternalLink,
  IconCheck,
  IconReceiptTax,
  IconGauge,
  IconInfoCircle,
  IconMinus,
  IconEdit,
  IconArrowsLeftRight
} from "@tabler/icons-react";

// import { TagBadge } from '../components/tag_badge';
// import { CustomerHistory } from '../components/customer_history';
import { Action, ActionType, BaseResult, CramProductOrigin, Customer, KYC, investedAmountOfWealth, UserDataType, approximateWealth, averageAnnualIncome, FileTag, DocType, employmentOptions, sourcesOfIncome, sourcesOfWealth, ItemInfoEditedObj, CustomClaims, CreateAMSAccountRequest, RiskOverrideReasonRequest, RejectionFormValues, KYCStatusCode, newSourcesOfIncome, newSourcesOfWealth, contractLinksCollection, CompanyAuthorizedSignatories, PoliticalPosition, PoliticallyExposedType, ContractPoliticalPosition, LegacyPoliticalPosition, EditableComponentType, GenericProduct, CreateContractLink, KycAiPrecheck, AvailableKYCTags } from "../../types";
import {
  IconEye,
  IconAlertCircle,
} from "@tabler/icons-react";
import { FirebaseError } from "firebase/app";

import { showNotification } from "@mantine/notifications";

import { FilesList } from "../../components/files";
import GeneratePDFModal from "../../components/generate_pdf_modal";
import CustomerKycLinks from "./customer_kyc_links";
import { getAddressDetailsEnglish } from "../../helpers/addressHelpers";
import areAllFolderFilesTagged from "../../helpers/areAllFolderFilesTagged";
import { CustomInfoCard } from "./CustomInfoCard";
import { AiPrecheckCard } from "./AiPrecheckCard";
import { describeKycPurpose, KycPurposeBadges, summarizeKycPurpose, useKycProducts } from "./KycPurpose";
import CramOverrideModal from "./CramOverrideModal";
import { map } from "underscore";

import { DocTypes } from "../../components/file_card";
import EditableInfoCard from "./EditableInfoCard";
import { useFirestore, useFunctions } from "../../helpers/firebaseContext";
import useFirestoreCollection from "../../helpers/useFirestoreCollection";
import { ControllingPersonScreening, BeneficialOwnerScreening, NapierAmlScreeningView } from '../../components/napier_aml_screening_view';
import { notifications } from '@mantine/notifications';
import CustomRejectionModal from '../../components/custom_rejection_modal';
import CustomProductComment from '../../components/custom_product_comment';
import CustomProductTimeline from '../../components/custom_product_timeline';
import SendPromotionalMaterial from "../../components/promotional_materials_modal";
import { useCanSendPromotionalMaterial } from "../../helpers/useCanSendPromotionalMaterial";
import AddFamilyMemberModal from "../../components/add_family_member_modal";
import { useDisclosure } from '@mantine/hooks';
import { InterviewFormModal } from './InterviewFormModal';
import { doc, getDoc } from 'firebase/firestore';
import order from "../orders/order";
import { link } from "jodit/esm/plugins/link/link";
import PepModificationModal from "../../components/PepModificationModal";
import { PDFImage } from "pdf-lib";
import { KycListTableViewer } from './KycListTableViewer';
import { getCountriesList } from '../../utils';
import { openRiskRatingPdf, openCramRiskPdf } from "../../helpers/riskRatingPdf";
import classesGuardian from '../../guardian_accordion.module.css';


export interface CustomerKYCProps {
  customerData: Customer;
  showButton: boolean;
  /** When false, hide name + CIF (e.g. customer page already shows them in its header). Defaults to true for order/service embeds. */
  showIdentityHeader?: boolean;
  showKycVersion: boolean;
  showActiveLinks: boolean;
  showGeneratePDF: boolean;
  disableUpload?: boolean
  hideHeaderButton?: boolean
  metaTypes: DocType[];
  kycID?: string
  setMetaTypes: React.Dispatch<React.SetStateAction<DocType[]>>;
}

export const parseDayFirst = (dateString: string) => {
  const parts = dateString.split("/");
  return new Date(
    parseInt(parts[2], 10),
    parseInt(parts[1], 10) - 1,
    parseInt(parts[0], 10),
  );
};

type FirestoreDateLike = Timestamp | Date | string | {
  toDate?: () => Date;
  seconds?: number;
  nanoseconds?: number;
  _seconds?: number;
  _nanoseconds?: number;
};

const toDateValue = (value?: FirestoreDateLike | null): Date | undefined => {
  if (!value) return undefined;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? undefined : value;
  if (typeof value === "string") {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
  }
  if (typeof value.toDate === "function") {
    const date = value.toDate();
    return Number.isNaN(date.getTime()) ? undefined : date;
  }

  const seconds = typeof value._seconds === "number" ? value._seconds : value.seconds;
  const nanoseconds = typeof value._nanoseconds === "number" ? value._nanoseconds : value.nanoseconds;
  if (typeof seconds !== "number") return undefined;

  const date = new Date((seconds * 1000) + ((nanoseconds ?? 0) / 1000000));
  return Number.isNaN(date.getTime()) ? undefined : date;
};

const formatDateValue = (value?: FirestoreDateLike | null): string => (
  toDateValue(value)?.toLocaleDateString("en-gb") ?? "/"
);

// CRAM Task 8 — badge colors for the rating + AI-mapping status.
const cramRatingColor = (rating?: string): string => {
  switch ((rating || "").toLowerCase()) {
    case "low":
      return "green";
    case "medium":
      return "yellow";
    case "high":
      return "red";
    case "prohibited":
      return "dark";
    default:
      return "gray";
  }
};

// Normalizes the KYC `employment` field (array or legacy scalar) to a list of
// employment values for display in the CRAM breakdown.
const cramEmploymentValues = (raw: any): string[] => {
  if (Array.isArray(raw)) return raw.filter((x: any) => typeof x === "string" && x.length > 0);
  if (typeof raw === "string" && raw.length > 0) return [raw];
  return [];
};

// Friendly labels for the engine's scoring categories (used by the combined
// AML breakdown table).
const CRAM_CATEGORY_LABELS: Record<string, string> = {
  customerType: "Customer type",
  geography: "Geography",
  productsServices: "Products & services",
  industryType: "Industry / occupation",
  directHigh: "Direct high-risk",
};

type CramRowStatus = "used" | "missing" | "unscored" | "none";

// One combined row per engine category: the category's score/weight plus the
// KYC input(s) that fed it and whether that input actually scored. Merges what
// used to be two separate tables (category scoring + CRAM inputs). A mandatory
// category with no input is "missing"; an input that resolved to score 0 (e.g.
// a product key that doesn't match a scored list item, or an unmapped
// occupation) is "unscored" — both surface as a yellow "something is not
// correct" warning so AML knows a recompute / mapping fix is due.
interface CramBreakdownRow {
  category: string;
  label: string;
  input: string;
  chosenKey: string;
  // Every value the engine weighed for this category, with its own score and
  // whether it won the per-category MAX. Empty for older snapshots (no
  // `candidates` field) and for Direct High (which shows friendly reasons in
  // `input` instead). `origin` is only set on productsServices, marking what
  // the customer is applying for versus what they already hold.
  candidates: { key: string; score: number; chosen: boolean; origin?: CramProductOrigin }[];
  score: number;
  weighted: number;
  mandatory: boolean;
  status: CramRowStatus;
}

const getCramBreakdownRows = (kyc: KYC): CramBreakdownRow[] => {
  const cats = kyc.cram?.breakdown?.categories || [];

  const empValues = cramEmploymentValues((kyc as any).employment ?? (kyc as any).employment_status);
  const clientNature = Array.isArray(kyc.clientNature) ? kyc.clientNature : [];
  const occ = kyc.aiMapping?.occupation;
  const ind = kyc.aiMapping?.industry;
  const occKey = occ?.selected ? occ.selected.key : occ?.suggestion?.suggestedKey;
  const indKey = ind?.selected ? ind.selected.key : ind?.suggestion?.suggestedKey;
  const hasEmploymentText = !!(
    kyc.employment_occupation || kyc.employment_jobTitle ||
    kyc.employment_industry_type || kyc.employment_employer
  );
  const dhReasons = kyc.cram?.directHighReasons || [];

  const inputFor = (category: string, chosenKey: string): string => {
    switch (category) {
      case "customerType":
        return [
          clientNature.length ? `Nature: ${clientNature.join(", ")}` : "",
          empValues.length ? `Employment: ${empValues.join(", ")}` : "",
        ].filter(Boolean).join(" · ");
      case "geography":
        return [kyc.nationality, kyc.residence].filter(Boolean).join(" / ");
      case "productsServices":
        return chosenKey || "";
      case "industryType":
        return [occKey, indKey].filter(Boolean).join(" / ");
      case "directHigh":
        return dhReasons.length ? dhReasons.join(", ") : "No high-risk factors";
      default:
        return "";
    }
  };

  const presenceFor = (category: string, chosenKey: string): boolean => {
    switch (category) {
      case "customerType":
        return clientNature.length > 0 || empValues.length > 0;
      case "geography":
        return !!(kyc.nationality || kyc.residence);
      case "productsServices":
        return !!chosenKey;
      case "industryType":
        return !!(occKey || indKey);
      case "directHigh":
        return true;
      default:
        return false;
    }
  };

  const mandatoryFor = (category: string): boolean => {
    switch (category) {
      case "customerType":
      case "geography":
      case "directHigh":
        return true;
      case "industryType":
        return hasEmploymentText;
      default:
        return false;
    }
  };

  return cats.map((c) => {
    const chosenKey = c.chosenKey || "";
    const score = c.maxScore;

    // Direct High is a High-floor, not a weighted MAX the reviewer picks from:
    // a "yes" flags the customer High, otherwise it has no effect. So it is
    // never "missing", we don't render candidate keys (the friendly reason
    // labels live in `input`), and its status reflects whether it fired.
    if (c.category === "directHigh") {
      const fired = dhReasons.length > 0;
      return {
        category: c.category,
        label: CRAM_CATEGORY_LABELS[c.category] || c.category,
        input: fired ? dhReasons.join(", ") : "No high-risk factors",
        chosenKey: "",
        candidates: [],
        score,
        weighted: c.weighted,
        mandatory: false,
        status: fired ? "used" : "none",
      };
    }

    const mandatory = mandatoryFor(c.category);
    const present = presenceFor(c.category, chosenKey);
    let status: CramRowStatus;
    if (!present && mandatory) {
      status = "missing";
    } else if (present && !chosenKey) {
      // Input given but it did not resolve to any list item.
      status = "unscored";
    } else if (present && !!chosenKey) {
      // Resolved to a list item — "used" even when that item legitimately
      // scores 0, so a real zero-score pick isn't flagged as a problem.
      status = "used";
    } else {
      status = "none";
    }
    return {
      category: c.category,
      label: CRAM_CATEGORY_LABELS[c.category] || c.category,
      input: inputFor(c.category, chosenKey),
      chosenKey,
      candidates: Array.isArray(c.candidates) ? c.candidates : [],
      score,
      weighted: c.weighted,
      mandatory,
      status,
    };
  });
};

const isActiveKycLink = (link: any): boolean =>
  link.filledData?.accept_terms !== true &&
  link?.status !== 'submitted' &&
  link?.status !== 'cancelled' &&
  link?.cancelled !== true;


export interface ObjectArrayType { label: string; value: string };


//create CustomerInfo component
export const CustomerKYC = ({ customerData, showButton, showActiveLinks, showKycVersion, showGeneratePDF, setMetaTypes, metaTypes, disableUpload = false, showIdentityHeader = true, hideHeaderButton = false, kycID }: CustomerKYCProps) => {
  // const { id } = useParams();
  // const { state } = useLocation();


  const db = useFirestore();
  const auth = getAuth(db.app);
  // every order / service (own + minors') grouped by kyc_id — tells us what each KYC was submitted for
  const kycProductsByKyc = useKycProducts(customerData?.id);
  const intl = useIntl();


  // Build lookup once, outside component
  const countryMap = Object.fromEntries(
    getCountriesList().map(c => [c.value, c.label])
  );

  const [searchParams] = useSearchParams();

  // Start -- GuardianKyc (minor accounts)
  const location = useLocation();

  // location.pathname = '/services/nlGn5W3Z5xjGsZhYlcrw'
  const segments = location.pathname.split('/').filter(Boolean);
  // segments = ['services', 'nlGn5W3Z5xjGsZhYlcrw']

  const productType = segments[0]; // 'services'
  const productID = segments[1];   // 'nlGn5W3Z5xjGsZhYlcrw'

  const [genericProduct, setGenericProduct] = useState<GenericProduct | null>(null);
  const [guardianKyc, setGuardianKyc] = useState<KYC | null>(null);
  const [guardianCustomer, setGuardianCustomer] = useState<Customer | null>(null);

  const productPath = customerData.id && productType && productID
    ? `customers/${customerData.id}/${productType}/${productID}`
    : null;

  const productRef = productPath ? doc(db, productPath) : null;

  useEffect(() => {
    if (!productRef) return;
    const unsubscribe = onSnapshot(productRef, (snapshot) => {
      if (snapshot.exists()) {
        setGenericProduct({ id: snapshot.id, ...snapshot.data() } as GenericProduct);
      } else {
        setGenericProduct(null);
      }
    });
    return () => unsubscribe();
  }, [productPath]);


  const translateArrayObj = (array: string[]): ObjectArrayType[] => {
    return array.map((keyValue) => {
      return {
        value: keyValue,
        label: (intl.formatMessage({ id: keyValue })) as string
      }
    }
    )
  }
  const userData: UserDataType = useContext(MyUserDataContext);
  const canSendPromotionalMaterial = useCanSendPromotionalMaterial();
  let userClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims || {};

  // CRAM rollout switch (config/cram.mode) — App.tsx loads the whole `config`
  // collection into ConfigContext, so `config.cram.mode` is available here.
  const appConfig = useContext(ConfigContext) as any;
  // Match the backend's readConfig fallback (shared-helpers/src/cramHelper.ts):
  // a legacy config seeded before `mode` existed but with audience.enabled === true
  // is treated as live. Reading `mode` alone here would show CRAM as inactive on
  // the page while the backend treats it as live.
  const cramMode: string =
    appConfig?.cram?.mode ?? (appConfig?.cram?.audience?.enabled ? "live" : "off");
  const isCramShadow = cramMode === "shadow";
  const isCramLive = cramMode === "live";

  const customDocTypes: Record<string, DocType> = {
    ...DocTypes,
  };
  // Allow uploading PaymentSlip as upload_docs will be mainly used for KFH Trade
  // delete customDocTypes[FileTag.PaymentSlip];
  // delete customDocTypes[FileTag.LinkKYC]; // This is not a file tag, it's a link to KYC update
  // delete customDocTypes[FileTag.AMLScreening]; // This is added by the CR team
  // delete customDocTypes[FileTag.finalSignedAgreement]; // This will never be asked from the client, so we remove it from the picker




  //make pending state
  const [pending, setPending] = useState<boolean>(false);
  const [pendingCreateAMS, setPendingCreateAMS] = useState<boolean>(false);
  const [pendingManualKYC, setPendingManualKYC] = useState<boolean>(false);
  const [riskRatingPdfGenerating, setRiskRatingPdfGenerating] = useState<boolean>(false);
  const [cramRiskPdfGenerating, setCramRiskPdfGenerating] = useState<boolean>(false);
  // CRAM Task 8 — result panel + AI mapping override UI state.
  const [cramBreakdownOpen, setCramBreakdownOpen] = useState<boolean>(false);
  const [cramOccupationOptions, setCramOccupationOptions] = useState<{ value: string; label: string }[]>([]);
  const [cramIndustryOptions, setCramIndustryOptions] = useState<{ value: string; label: string }[]>([]);
  const [cramMappingSaving, setCramMappingSaving] = useState<null | "occupation" | "industry">(null);
  // CRAM mapping "Change" modal state.
  const [cramChangeModal, setCramChangeModal] = useState<
    null | { target: "occupation" | "industry"; label: string; currentKey: string | null; options: { value: string; label: string }[] }
  >(null);
  const [cramChangeValue, setCramChangeValue] = useState<string | null>(null);
  const [confirming, setConfirming] = useState<boolean>(false);
  const [links, setLinks] = useState([] as any[]);
  const [kycLinks, setKYCLinks] = useState([] as any[]);
  const [generatePDFOpen, setGeneratePDFOpen] = useState<boolean>(false);
  const [promotionalMaterialModalOpen, setPromotionalMaterialModalOpen] = useState<boolean>(false);
  const [familyMemberModalOpen, setFamilyMemberModalOpen] = useState<boolean>(false);

  const [msg, setMsg] = useState<string | null>(null);
  const [isError, setIsError] = useState<boolean>(false);
  const [sendSMS, setSendSMS] = useState<boolean>(false);

  // const [overrideCivilID, setOverrideCivilID] = useState<boolean>(false);
  // const [overridePassport, setOverridePassport] = useState<boolean>(false);

  const [KYCDoc, setKYCDoc] = useState<QueryDocumentSnapshot<KYC> | undefined>(undefined);
  const [updatedKYCData, setUpdatedKYCData] = useState<ItemInfoEditedObj<KYC>>({});
  const [originalSubmission, setOriginalSubmission] = useState<{ path: string; at?: Date; error?: boolean }>();
  const selectedKycPath = KYCDoc?.ref.path;
  useEffect(() => {
    if (!selectedKycPath) return;
    const controller = new AbortController();
    setOriginalSubmission({ path: selectedKycPath });
    const useEmulator = import.meta.env.DEV && /^(true)$/i.test(import.meta.env.VITE_OVERRIDE_FIREBASE_CONFIG ?? '');
    const baseUrl = useEmulator ? `http://${import.meta.env.VITE_FIRESTORE_EMULATOR_HOST || 'localhost'}:${Number(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT) || 8080}` : undefined;
    getKycCreationTime(db.app.options.projectId!, selectedKycPath, async () => {
      if (!auth.currentUser) throw new Error('Authentication required');
      return auth.currentUser.getIdToken();
    }, { baseUrl, signal: controller.signal }).then(at => {
      if (!controller.signal.aborted) setOriginalSubmission({ path: selectedKycPath, at });
    }).catch(() => {
      if (!controller.signal.aborted) setOriginalSubmission({ path: selectedKycPath, error: true });
    });
    return () => controller.abort();
  }, [auth, db, selectedKycPath]);
  const originalSubmittedAt = originalSubmission?.path === selectedKycPath ? originalSubmission?.at : undefined;
  const originalSubmissionError = originalSubmission?.path === selectedKycPath && !!originalSubmission?.error;
  const originalSubmissionLoading = !!selectedKycPath && !originalSubmittedAt && !originalSubmissionError;

  const data = useMemo(() => {
    if (!KYCDoc) return undefined;
    const d = KYCDoc.data() as KYC;
    d.id = KYCDoc.id;
    return d;
  }, [KYCDoc]);
  const kycData = data as KYC | undefined;
  // A minor's KYC is a mirror of the guardian's submission and is never scored
  // by CRAM: it carries whatever rating the guardian has. So no risk card, no
  // CRAM card, no mapping to confirm and no CRAM gates on this page — all of
  // that lives on the guardian's KYC. Mirrors cramHelper.isMinorKyc on the
  // server.
  const isMinorKyc = !!(kycData?.guardianCustomerID && kycData?.guardianKycID);
  // New (contract-based) KYCs carry a completedKYCData snapshot; legacy KYCs don't.
  // Same check the sources-of-income/wealth option lists use below.
  const isNewContractKyc = !!(data?.completedKYCData && data?.completedKYCData?.id);
  const politicalPositionOptions = translateArrayObj(Object.values(PoliticalPosition));


  console.log("KYC DATA IS FOUND HERE =======>", data);

  const [privateData, setPrivateData] = useState(null as any);
  const aiPrecheck = (privateData?.ai_precheck ?? null) as KycAiPrecheck | null;

  //this looks absolutely terrible.  I much preferred the chaining method used previously.
  const kycQuery = useMemo(() => {
    const kycCollection = collection(db, "customers", customerData.id as string, "kyc");

    return kycID
      ? query(kycCollection, where(documentId(), "==", kycID))
      : query(kycCollection, orderBy("created", "desc"));
  }, [customerData.id, db, kycID]);
  const functions = useFunctions();
  functions.region = "europe-west1";

  const kycAction = httpsCallable<Action, BaseResult>(functions, "kycAction");
  const riskOverride = httpsCallable(functions, "riskOverride");
  const riskOverrideKYC = httpsCallable<RiskOverrideReasonRequest, BaseResult>(functions, "riskOverrideKYC");
  const createAMSAccount = httpsCallable<CreateAMSAccountRequest, BaseResult>(functions, "createAMSAccount");
  // productRef is not used for user KYC links, hence the Partial
  const createContractUserKYCLink = httpsCallable<Partial<CreateContractLink>, BaseResult>(functions, "createContractUserKYCLink", { timeout: 540000 });
  // CRAM Task 8 — CR override of the AI industry/occupation mapping.
  const cramSetAiMappingOverride = httpsCallable<
    { customerID: string; kycID: string; target: "occupation" | "industry"; key: string | null },
    BaseResult
  >(functions, "cramSetAiMappingOverride");
  // One manual AI industry/occupation mapping run per KYC, for the case where
  // the background mapping never fired.
  const cramRequestAiMapping = httpsCallable<
    { customerID: string; kycID: string },
    BaseResult
  >(functions, "cramRequestAiMapping");

  // const oneTimeOverrideKYC = httpsCallable(functions, "oneTimeOverrideKYC");
  const [allFilesTagged, setAllFilesTagged] = useState<boolean>(true);

  // CRAM Task 8 — lazily load the occupation / industry_sectors lists so the
  // CR can pick an override mapping. Only fetched once a CRAM-bound KYC (or an
  // AI mapping) is present, and only by users allowed to override.
  useEffect(() => {
    // Loaded for anyone who can see the mapping card, whether or not a CRAM
    // snapshot / AI mapping exists yet: a KYC with neither is precisely the one
    // where CR has to pick the values by hand, and without the lists the Update
    // control has nothing to offer and stays disabled.
    const canOverride = !!(userClaims.cr || userClaims.admin);
    if (!canOverride) return;
    if (cramOccupationOptions.length > 0 && cramIndustryOptions.length > 0) return;

    let cancelled = false;
    const toOptions = (snap: any): { value: string; label: string }[] =>
      snap.docs
        .map((d: any) => {
          const item = d.data();
          const en = item?.labelEn || "";
          const ar = item?.labelAr || "";
          const label = [en, ar].filter(Boolean).join(" / ") || d.id;
          return { value: d.id as string, label };
        })
        .sort((a: { label: string }, b: { label: string }) => a.label.localeCompare(b.label));

    (async () => {
      try {
        const [occSnap, indSnap] = await Promise.all([
          getDocs(collection(db, "cram_lists", "occupation", "items")),
          getDocs(collection(db, "cram_lists", "industry_sectors", "items")),
        ]);
        if (cancelled) return;
        setCramOccupationOptions(toOptions(occSnap));
        setCramIndustryOptions(toOptions(indSnap));
      } catch (e) {
        console.error("Failed to load CRAM mapping lists", e);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userClaims.cr, userClaims.admin]);

  const [missingFiles, setMissingFiles] = useState<FileTag[]>([]);

  const navigate = useNavigate();

  const { loading: kycQueryLoading, snapshot: kycDocs } = useFirestoreCollection(kycQuery);

  // "What is this KYC for?" — needs kycDocs (history) and privateData (actions), so it lives after both.
  const olderKycExistsFor = (id?: string): boolean | undefined => {
    if (!id || !kycDocs) return undefined;
    const idx = kycDocs.docs.findIndex((d) => d.id === id);
    if (idx < 0) return undefined;
    return idx < kycDocs.docs.length - 1; // docs are ordered by created desc
  };
  const kycPurposeItems = useMemo(
    () => describeKycPurpose({
      kyc: kycData ? { ...kycData, id: KYCDoc?.id ?? kycData.id } : undefined,
      customerID: customerData?.id,
      productsByKyc: kycProductsByKyc,
      links: kycLinks,
      actions: privateData?.actions?.approvals ?? [],
      // kycDocs is the full history (created desc) unless a single kycID was requested
      olderKycExists: kycID ? undefined : olderKycExistsFor(KYCDoc?.id),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [kycData, KYCDoc?.id, customerData?.id, kycProductsByKyc, kycLinks, privateData?.actions?.approvals, kycDocs, kycID],
  );
  const [loadingAML, setAMLLoading] = useState(false);

  const [kycRef, setKycRef] = useState<DocumentReference>();

  // Hold latest snapshot data from both listeners
  const kycRowsRef = useRef<any[]>([]);
  const contractRowsRef = useRef<any[]>([]);

  const [interviewModalOpened, { open: openInterviewModal, close: closeInterviewModal }] = useDisclosure(false);
  const [pepModificationModalOpened, { open: openPepModificationModal, close: closePepModificationModal }] = useDisclosure(false);

  const authorizedSignatories = customerData.authorized_signatories;
  const [enrichedSignatories, setEnrichedSignatories] = useState<CompanyAuthorizedSignatories[]>([]);
  const [signatureLinkModalOpened, { open: openSignatureLinkModal, close: closeSignatureLinkModal }] = useDisclosure(false);

  const [selectedSignatoryId, setSelectedSignatoryId] = useState<string | null>(null);
  const [sendingSignatureLink, setSendingSignatureLink] = useState(false);
  const [signatureLinkError, setSignatureLinkError] = useState<string | null>(null);
  const [opened, { toggle }] = useDisclosure(true);

  const clearPoliticalPositionField = async (field: "politicalPosition" | "relativePoliticalPosition") => {
    if (!kycRef || !kycData) return;
    const updatedDataEntry = {
      updated_by: userData.user?.email!,
      updated_on: Timestamp.now(),
      initial_value: [{ [field]: (kycData as any)?.[field] ?? "" }],
      updated_fields: [{ [field]: "DELETED" }],
      reason: "Removed from customer KYC political position card",
    };
    await setDoc(kycRef, {
      [field]: deleteField(),
      updated_data: arrayUnion(updatedDataEntry as any),
    }, { merge: true });
  };

  const [openAccordions, setOpenAccordions] = useState<string[]>(["guardian_kyc"])
  // For minors the product's KYC lives under the guardian's customer doc:
  // guardianCustomerID is the guardian, kyc_id the doc in their kyc collection.
  const guardianCustomerID = genericProduct?.guardianCustomerID;
  const guardianKycID = genericProduct?.kyc_id;


  // If direct customers/10459818 and user have guardian KYC Data
  const guardianCustomerIDFromDb = (kycData as any)?.guardianCustomerID;
  const guardianKycIDFromDb = (kycData as any)?.guardianKycID;

  const resolvedGuardianCustomerID = guardianCustomerID ?? guardianCustomerIDFromDb;
  const resolvedGuardianKycID = guardianKycID ?? guardianKycIDFromDb;

  useEffect(() => {
    if (!resolvedGuardianCustomerID) {
      setGuardianCustomer(null);
      setGuardianKyc(null);
      return;
    }

    const unsubs: Unsubscribe[] = [];

    // guardian customer
    const customerRef = doc(db, "customers", resolvedGuardianCustomerID);
    unsubs.push(
      onSnapshot(customerRef, (snap) => {
        setGuardianCustomer(snap.exists() ? ({ id: snap.id, ...snap.data() } as Customer) : null);
      })
    );

    // guardian KYC
    if (resolvedGuardianKycID) {
      const kycRef = doc(db, "customers", resolvedGuardianCustomerID, "kyc", resolvedGuardianKycID);
      unsubs.push(
        onSnapshot(kycRef, (snap) => {
          setGuardianKyc(snap.exists() ? ({ id: snap.id, ...snap.data() } as KYC) : null);
        })
      );
    } else {
      setGuardianKyc(null);
    }

    return () => unsubs.forEach((u) => u());
  }, [resolvedGuardianCustomerID, resolvedGuardianKycID]);


  const tagsByCode = Object.fromEntries(
    Object.values(AvailableKYCTags).map((t) => [t.code, t])
  ) as Record<string, typeof AvailableKYCTags[keyof typeof AvailableKYCTags]>;
  // End -- GuardianKyc

  const handleSendSignatureLink = async () => {
    if (!selectedSignatoryId) return;
    setSendingSignatureLink(true);
    try {

      //generate a doc ID
      const newDocRef = doc(collection(db, "sms"));
      let docID = newDocRef.id;
      const contractKYCUpdate = httpsCallable<RejectionFormValues, BaseResult>(functions, "contractKYCUpdate", { timeout: 540000 });

      const token = await userData.getAzureADToken!(userData);
      if (!token && !userClaims?.kfh_rm_approver) {
        throw new Error("No Microsoft token.  Try refreshing");
      }

      if (!kycData?.customerID) {
        throw new Error("No Customer ID associated with KYC.");
      }

      const formData: RejectionFormValues = {
        comments: '',
        sendSMS: true,
        usePACI: true,
        action: 'signature_link_sent' as ActionType,
        linkInfo: {
          updateType: 'needs_update',
          senderID: 'KFHC-KYC',
          updateKycID: kycData?.id,
          customerID: kycData?.customerID,
          useWhatsapp: true,
          usePACI: true,
          smsDocID: docID,
        },
        selectedPages: ['kyc_requirements', 'paci_authentication', 'agreement_submit_entity', 'kyc_thank_you'],
        kycID: kycData?.id,
        token: token,
        customerID: kycData?.customerID,
        selectedSignatoryId: selectedSignatoryId,
      };

      const res = await contractKYCUpdate(formData);

      closeSignatureLinkModal();
    } catch (e: any) {
      console.error('Signature link error:', e.code, e.message, e.details);
      setSignatureLinkError(e.message ?? 'Something went wrong.');
    } finally {
      setSendingSignatureLink(false);
    }
  };

  useEffect(() => {
    if (!authorizedSignatories?.length) {
      setEnrichedSignatories([]);
      return;
    }
    const fetchCustomers = async () => {
      const enriched = await Promise.all(
        authorizedSignatories.map(async (s) => {
          try {
            const snap = await getDoc(doc(db, 'customers', s.id));
            return {
              ...s,
              customer: snap.exists() ? (snap.data() as Customer) : undefined,
            };
          } catch (e) {
            return s;
          }
        })
      );
      console.log('Enriched signatories:', enriched.length);
      setEnrichedSignatories(enriched);
    };


    fetchCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(authorizedSignatories?.map((s) => s.id))]);




  const getUpdatedKycData = (kycDataDoc: QueryDocumentSnapshot<KYC>): ItemInfoEditedObj<KYC> => {
    let updatedDataObj: ItemInfoEditedObj<KYC> = {};

    if (!kycDataDoc.data().updated_data?.length) {
      return updatedDataObj;
    }

    const dataKeys = map(
      kycDataDoc.data().updated_data!,
      (value) => map(value?.updated_fields!, (innerValue) => Object.keys(innerValue)),
    );
    updatedDataObj = dataKeys?.flat(2).reduce((o, key) => ({ ...o, [key]: {} }), {});

    kycDataDoc.data().updated_data!.forEach((objEntry) => {
      objEntry?.updated_fields?.forEach((updatedField: { [key: string]: (string | null)[] | number | string }) => {
        const objKey = Object.keys(updatedField)[0] as keyof KYC;
        updatedDataObj = {
          ...updatedDataObj,
          [objKey]: {
            ...updatedDataObj[objKey],
            currentValue: updatedField[objKey],
            updatedOn: objEntry?.updated_on!,
            updatedBy: objEntry?.updated_by!,
          },
        };
      });

      objEntry?.initial_value?.forEach((previousField: { [key: string]: (string | null)[] | number | string }) => {
        const objKey = Object.keys(previousField)[0] as keyof KYC;
        updatedDataObj = {
          ...updatedDataObj,
          [objKey]: {
            ...updatedDataObj[objKey],
            previousValue: previousField[objKey],
            updatedOn: objEntry?.updated_on!,
            updatedBy: objEntry?.updated_by!,
            reason: objEntry?.reason ?? '',
          },
        };
      });
    });

    return updatedDataObj;
  };

  const selectKycDoc = (kycDataDoc?: QueryDocumentSnapshot<KYC>) => {
    if (!kycDataDoc) {
      return;
    }

    setKycRef(kycDataDoc.ref);
    setKYCDoc(kycDataDoc);
    setUpdatedKYCData(getUpdatedKycData(kycDataDoc));
    setPrivateData(null);
    setActionsAfterRejection([]);
  };

  useEffect(() => {

    if (kycDocs && !kycDocs.empty && kycDocs.docs[0]) {
      let kycDataDoc = kycDocs.docs[0] as QueryDocumentSnapshot<KYC>
      // an explicit kycID prop wins; otherwise honor a ?kyc= query param
      // (written on KYC selection, and by "Open guardian's KYC" links on minors' products)
      const requestedKycID = kycID ?? searchParams.get("kyc");
      if (requestedKycID) {
        const requestedDoc = kycDocs.docs.find((docObj) => docObj?.id === requestedKycID);
        if (requestedDoc) {
          kycDataDoc = requestedDoc as QueryDocumentSnapshot<KYC>;
        }
      }
      selectKycDoc(kycDataDoc);
    }
  }, [kycDocs, kycID, searchParams])


  const [actionsAfterRejection, setActionsAfterRejection] = useState(
    [] as any
  );

  useEffect(() => {
    console.log("Running customer kyc effect!");

    const customerLinksCollection = collection(db, "kycupdatelinks");
    const contractLinksCollectionList = collection(db, contractLinksCollection);

    const kycLinksQuery = query(customerLinksCollection, where("customerID", "==", customerData?.id), orderBy("expires", "desc"));
    const contractLinksQuery = query(contractLinksCollectionList, where("customerId", "==", customerData?.id), orderBy("expires", "desc"));

    // console.log(db, "customers", id as string, "kyc", data.id, "private");

    // Reset both refs when KYCDoc changes (new customer)
    kycRowsRef.current = [];
    contractRowsRef.current = [];
    setPrivateData(null);
    setActionsAfterRejection([]);

    const mergeAndSet = () => {
      const combined = [...kycRowsRef.current, ...contractRowsRef.current]
        .sort((a, b) => b.expires?.seconds - a.expires?.seconds);
      setKYCLinks(combined);
    };

    const kycLinksUnsubscriber = onSnapshot(kycLinksQuery, (snapshot) => {
      console.log(snapshot.metadata.fromCache ? "Cached data" : "Server data", snapshot.docs.length);
      kycRowsRef.current = snapshot.docs.map((doc) => {
        const data = doc.data();
        data.ref = doc.ref;
        data.id = doc.id;
        data.confirming = false;
        data.is_contract = false; // kycupdatelinks = always false
        return data;
      });
      mergeAndSet();
    });

    const contractLinksUnsubscriber = onSnapshot(contractLinksQuery, (snapshot) => {
      console.log(snapshot.metadata.fromCache ? "Cached contract data" : "Server contract data", snapshot.docs.length);
      contractRowsRef.current = snapshot.docs.map((doc) => {
        const data = doc.data();
        data.ref = doc.ref;
        data.id = doc.id;
        data.confirming = false;
        data.is_contract = true; // contract_links = always true
        return data;
      });
      mergeAndSet();
    });

    //does nothing but we need it so it doesn't lose scope
    let privateDataUnsubscriber: Unsubscribe;


    if (KYCDoc && customerData?.id) {


      const privateDataRef = collection(
        KYCDoc!.ref,
        "private",
      );
      privateDataUnsubscriber = onSnapshot(privateDataRef, (snapshot) => {
        let docs = snapshot.docs;
        //convert it to a dictionary and set it to the state
        let pdata: any = {};
        docs.forEach((doc: any) => {
          pdata[doc.id] = doc.data();
        });

        setPrivateData(pdata);
        console.log("Private daa", pdata);

        if (
          pdata &&
          pdata.actions &&
          pdata.actions.approvals &&
          pdata.actions.approvals.length > 0
        ) {
          let approvals = pdata.actions.approvals;

          for (let i = pdata.actions.approvals.length - 1; i >= 0; i--) {
            if (["needs_update", "needs_agent_update"].includes(pdata.actions.approvals[i].type)) {
              approvals = pdata.actions.approvals.slice(i + 1);
              break;
            }
          }
          console.log("filled out actions!");
          setActionsAfterRejection(approvals);
        } else {
          setActionsAfterRejection([]);
        }
      });
    }

    //TODO: just scrape the directory

    console.log("We are returning cleanup function");

    return () => {
      privateDataUnsubscriber?.();  //this could be undefined, which is why we have a ?.
      kycLinksUnsubscriber();
      contractLinksUnsubscriber();
      console.log("Cleanup..")
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [KYCDoc]);

  // console.log(data);



  const [confirmDialog, setConfirmDialog] = useState<any>(null);
  // const [manualEntryDialog, setManualEntryDialog] = useState<any>(null);
  const [confirmDialogError, setConfirmDialogError] = useState<any>(null);

  // Which CRAM override action is open, if any. CramOverrideModal owns the
  // rating / reason / error draft, so there is nothing to reset here.
  const [cramOverrideMode, setCramOverrideMode] = useState<"apply" | "remove" | null>(null);
  // Manual "Call AI" mapping run.
  const [aiMappingCallBusy, setAiMappingCallBusy] = useState(false);

  const form = useForm<Action>({
    initialValues: {
      comments: "",
      action: "approve",  //temporary.
      token: "",
      linkInfo: {
        smsMessage: "",
        updateType: "none",
        senderID: "KFHC-KYC",
      }
    },
    validate: {
      comments: (val) => (!val || val.length > 0 ? null : "Please enter why you are rejecting this request"),
    }
  });
  const renderProductTimeline = useMemo(() => (
    <CustomProductTimeline
      key={KYCDoc?.id ?? "kyc-actions"}
      approval={privateData?.actions?.approvals || []}
    />
  ), [KYCDoc?.id, privateData?.actions?.approvals]);
  const renderProductComment = useMemo(() => {
    if (!kycRef) return null;

    return <CustomProductComment key={kycRef.path} collectionRef={kycRef} />
  }
    ,
    [kycRef]);
  /*
    const manualEntryForm = useForm({
      initialValues: {
        birthDate: "",
        name_en: "",
        name_ar: "",
        civilID: "",
        civilIDExpiryDate: "",
        passportNumber: "",
        passportExpiryDate: "",
        houseID: "",
        gender: "",
        nationality: "",
      } as any,
      // validate: {
      // },
    });
  
  */

  /*
  useEffect(() => {

    // console.log("customer data", customerData);

    if (!customerData) return;

    if (customerData.oneTimeOverrideKYCData?.overrideCivilID) {

      setOverrideCivilID(true)
      manualEntryForm.setFieldValue("civilIDExpiryDate", customerData.oneTimeOverrideKYCData.civilIDExpiryDate?.toDate())
      manualEntryForm.setFieldValue("houseID", customerData.oneTimeOverrideKYCData.houseID)
      manualEntryForm.setFieldValue("gender", customerData.oneTimeOverrideKYCData.gender)
      manualEntryForm.setFieldValue("nationality", Object.keys(COUNTRY_CODES).find(key => COUNTRY_CODES[key] === customerData?.oneTimeOverrideKYCData?.nationality))
    }
    else {
      manualEntryForm.setFieldValue("civilIDExpiryDate", null)
      manualEntryForm.setFieldValue("houseID", "")
      manualEntryForm.setFieldValue("gender", "")
      manualEntryForm.setFieldValue("nationality", "")
      setOverrideCivilID(false)
    }

    if (customerData.oneTimeOverrideKYCData?.overridePassport) {

      setOverridePassport(true)
      manualEntryForm.setFieldValue("passportExpiryDate",
        customerData.oneTimeOverrideKYCData!.passportExpiryDate?.toDate(),
      )
      manualEntryForm.setFieldValue("passportNumber", customerData.oneTimeOverrideKYCData.passportNumber)
    }
    else {
      manualEntryForm.setFieldValue("passportExpiryDate", null)
      manualEntryForm.setFieldValue("passportNumber", "")
      setOverridePassport(false)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData])
*/
  // const [manualEntryData, setManualEntryData] =useState<any>({
  //     birthDate: "",
  //     name_en: "",
  //     name_ar: "",
  //     civilID: "",
  //     civilIDExpiryDate: "",
  //     passportNumber: '',
  //     passportExpiryDate: '',
  //     houseID: "",
  //     gender: "",
  //     nationality: "",
  // } as any);

  // const civilIDExpiryDateRef = useRef<HTMLInputElement>(null);
  // const passportExpiryDateRef = useRef<HTMLInputElement>(null);

  // const manualModal = ();

  console.log("re-rendering!!");

  function formatNums(num: string, sep: string) {
    sep = sep || ",";
    return String(num).replace(/\.\d+|\d(?=(?:\d{3})+(?!\d))/g, function (a) {
      return a.length === 1 ? a + sep : a;
    });
  }

  const toKwd = (value?: string) => {
    if (!value) return undefined;
    return formatNums(value, ",") + " KD";
  };

  const formatAssistedBy = (value: unknown): string | undefined => {
    if (!value) return undefined;

    if (typeof value === "string") {
      return value;
    }

    if (Array.isArray(value)) {
      const assistedByList = value.map((item) => formatAssistedBy(item)).filter(Boolean);
      return assistedByList.length ? assistedByList.join(", ") : undefined;
    }

    if (typeof value === "object") {
      const assistedByObject = value as Record<string, unknown>;

      if (assistedByObject.displayName || assistedByObject.mail || assistedByObject.userPrincipalName || assistedByObject.id) {
        return [
          assistedByObject.displayName,
          assistedByObject.mail || assistedByObject.userPrincipalName || assistedByObject.id,
        ].filter(Boolean).join(" - ");
      }

      const assistedByList = Object.values(assistedByObject).map((item) => formatAssistedBy(item)).filter(Boolean);
      return assistedByList.length ? assistedByList.join(", ") : undefined;
    }

    return String(value);
  };

  // const kycURL = import.meta.env.MODE !== 'production' ? "http://localhost:64665" : (import.meta.env.VITE_ENV !== 'production') ? "https://kfh-capital-kyc-test.firebaseapp.com" : "https://kyc.kfhcapital.com.kw";

  //this is used for anyone who selects "other" as a choice in the KYC form.  It adds the text entered by the client as (text)
  const printArrayWithOthers = (key: keyof KYC): string => {
    let value: any = (data?.[key]);
    //is it an array?
    if (Array.isArray(value)) {

      //add translation to string values
      value = value.map((valueObj: any) => {
        // eslint-disable-next-line valid-typeof
        if ((typeof valueObj === 'string' || valueObj instanceof String || typeof valueObj === undefined) && valueObj !== "other") {
          return (intl.formatMessage({ id: valueObj })) as string
        }
        return valueObj
      });


      //does it have "other" in it?
      if (value.includes("other")) {
        //get the other value
        let otherValue = data?.[key + "_other_field" as keyof KYC];
        //if it's not empty, add it to the array
        if (otherValue) {
          value = value.map((val: any) => {
            return val === "other" ? `other (${otherValue})` : val;
          });
        }
      }
      return value.join(",");
    }

    if (typeof value === "string") {
      return (intl.formatMessage({ id: value })) as string;  //What is this?  It's not an array.  Just return it.
    }
    console.warn("Unknown type for key", key, value);
    return value;
  }

  const tagsAsString = (list: FileTag[]): string => {
    if (list === null || list === undefined || list.length === 0) {
      return "";

    }
    let msg = "Missing Files: ";
    msg = msg + list.map((tag) => DocTypes[tag].name).join(", ");

    return msg;
  }


  const renderGeneratePDFModal = React.useMemo(() => {
    return <GeneratePDFModal
      generatingForCollection="customer"
      rows={[{
        ...customerData, //iban: customerData?.idNumber || customerData?.iban,  //TOOD: What is this?  Should probably be fetched from accounts
        kyc_id: KYCDoc?.id,
        // "address": {
        //   ...customerData?.address,
        //   "DetailsEnglish": customerData?.address?.values?.join(',') ?? "",
        // }  //TODO: There's no customerData.address? 
      }]}
      kycID={KYCDoc?.id}
      includeKYC={true}
      completedKYCData={kycData?.completedKYCData ? {
        ...kycData.completedKYCData,
        kyc_id: kycData.id
      } : undefined}
      pdfTags={kycData?.pdfTags ? kycData.pdfTags : undefined}
      setPending={setPending}
      metaTypes={metaTypes}
      opened={generatePDFOpen}
      setOpened={setGeneratePDFOpen}

      aml_screening={KYCDoc?.data()?.aml_screening ?? {}}
    />;
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      metaTypes,
      generatePDFOpen,
    ]);


  const renderPromotionalMaterialModal = React.useMemo(() => {
    return <SendPromotionalMaterial
      customerData={customerData}
      opened={promotionalMaterialModalOpen}
      setOpened={setPromotionalMaterialModalOpen}

    />;
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [

      promotionalMaterialModalOpen,
    ]);

  const renderFamilyMemberModal = React.useMemo(() => {
    return <AddFamilyMemberModal
      customerData={customerData}
      opened={familyMemberModalOpen}
      setOpened={setFamilyMemberModalOpen}
    />;
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      familyMemberModalOpen,
    ]);

  if (kycQueryLoading) {
    return <Loader />;
  }



  const handleKYCRejection = async (values: RejectionFormValues): Promise<void> => {
    try {
      const token = await userData.getAzureADToken!(userData);
      if (!token && !userClaims?.kfh_rm_approver) {
        throw new Error("No Microsoft Token. Try refreshing.");
      }

      console.log("KYC rejection values:", values);

      // Determine action type based on updateType
      let action: ActionType = values.linkInfo?.updateType !== "none" ? "needs_update" : "reject";
      const chosenActionValue = values.action === "needs_agent_update" ? "needs_agent_update" : action;
      const res = await kycAction({
        action: chosenActionValue,
        kycID: KYCDoc?.id,
        customerID: customerData?.id,
        token: token || "",
        comments: values.comments,
        sendSMS: values.sendSMS,
        linkInfo: {
          updateKycID: KYCDoc?.id,
          smsMessage: values.linkInfo?.smsMessage,
          updateType: values.linkInfo?.updateType,
          senderID: values.linkInfo?.senderID,
          usePACI: values.usePACI,
        },
        missingFiles: values.missingFiles || [],
      });

      console.log("KYC action result:", res);
      notifications.show({
        title: 'Successfully',
        message: 'KYC rejected',
        color: 'green',
      });

    } catch (error: any) {
      console.error("KYC rejection error:", error);
      notifications.show({
        title: 'Unexpected Error',
        message: error.message || "Failed to reject KYC",
        color: 'red',
      });

      // Re-throw the error so the modal can handle it (show error in modal)
      throw error;
    }
  };
  // return "sup";


  const ImageViewCard = ({ photo, title = "Photo", h, w }: {
    photo?: string | PDFImage | ArrayBuffer | Uint8Array;
    title?: string;
    h?: number;
    w?: string;
  }) => {
    if (!photo) return null;

    return (
      <Paper shadow="xs" p="md">
        <Group>
          <ThemeIcon color="green" variant="light">
            <IconSchool size={16} />
          </ThemeIcon>
          <Title order={5}>{title}</Title>
        </Group>
        <Space h="xs" />
        <Center>
          <Image
            fit="contain"
            h={h}
            // Without explicit dimensions (signatures), cap at the signature
            // pad height and never upscale past the image's natural size —
            // Mantine's Image otherwise stretches to width: 100%.
            w={w ?? (h ? undefined : 'auto')}
            mah={h ? undefined : 200}
            maw="100%"
            radius="lg"
            src={`data:image/png;base64,${photo}`}
          />
        </Center>
      </Paper>
    );
  };

  const canGenerateRiskRatingPdf = !!(userClaims.admin || userClaims.cram || userClaims.risk);
  // The CRAM PDF exposes the score + calculation breakdown, so it is limited to
  // admin / CRAM and only when this KYC actually has a CRAM assessment.
  const canGenerateCramRiskPdf = !!((userClaims.admin || userClaims.cram) && kycData?.cram);

  const handleGenerateRiskRatingPdf = async () => {
    const previewWindow = window.open("", "_blank");
    setRiskRatingPdfGenerating(true);

    try {
      if (!kycData) throw new Error("No KYC data is loaded for this customer.");

      await openRiskRatingPdf({
        customer: customerData,
        kyc: kycData,
        riskCode: privateData?.state?.risk_code,
        riskLabel: privateData?.state?.risk,
      }, previewWindow);

      notifications.show({
        title: "Success",
        message: "Risk rating PDF generated",
        color: "green",
      });
    } catch (error: any) {
      previewWindow?.close();
      console.error("Risk rating PDF generation failed", error);
      notifications.show({
        title: "PDF generation failed",
        message: error?.message || "Unable to generate the risk rating PDF.",
        color: "red",
      });
    } finally {
      setRiskRatingPdfGenerating(false);
    }
  };

  const handleGenerateCramRiskPdf = async () => {
    const previewWindow = window.open("", "_blank");
    setCramRiskPdfGenerating(true);

    try {
      if (!kycData) throw new Error("No KYC data is loaded for this customer.");

      await openCramRiskPdf({
        customer: customerData,
        kyc: kycData,
        riskCode: privateData?.state?.risk_code,
        riskLabel: privateData?.state?.risk,
        breakdownRows: getCramBreakdownRows(kycData),
      }, previewWindow);

      notifications.show({
        title: "Success",
        message: "CRAM risk PDF generated",
        color: "green",
      });
    } catch (error: any) {
      previewWindow?.close();
      console.error("CRAM risk PDF generation failed", error);
      notifications.show({
        title: "PDF generation failed",
        message: error?.message || "Unable to generate the CRAM risk PDF.",
        color: "red",
      });
    } finally {
      setCramRiskPdfGenerating(false);
    }
  };

  // CRAM mapping — apply a CR confirm (key = AI suggestion) or change (chosen
  // key) via the callable, with proper loading + error surfacing.
  const applyCramMapping = async (
    target: "occupation" | "industry",
    key: string | null,
  ): Promise<boolean> => {
    setCramMappingSaving(target);
    try {
      await cramSetAiMappingOverride({
        customerID: customerData.id!,
        kycID: KYCDoc?.id!,
        target,
        key,
      });
      setMsg(`CRAM ${target} mapping updated.`);
      setIsError(false);
      return true;
    } catch (e: any) {
      setMsg(e?.message || "Failed to update mapping");
      setIsError(true);
      return false;
    } finally {
      setCramMappingSaving(null);
    }
  };

  // Per-row mapping state for the employment card + the approve/review gate.
  // Plain computed value (not a hook) so it is safe to define after the
  // `if (kycQueryLoading) return <Loader />` early return above.
  const cramMappingRows = (() => {
    const mapping = kycData?.aiMapping;
    const build = (
      target: "occupation" | "industry",
      entry: any,
      typed: string,
      options: { value: string; label: string }[],
    ) => {
      const suggestion = entry?.suggestion;
      const selected = entry?.selected;
      const hasInput = !!typed || !!suggestion?.suggestedKey;
      return {
        target,
        typed,
        suggestion,
        selected,
        options,
        effectiveKey: selected ? (selected.key ?? null) : (suggestion?.suggestedKey ?? null),
        resolved: !!selected,
        needsAttention: hasInput && !selected,
      };
    };
    return [
      build(
        "occupation",
        mapping?.occupation,
        [kycData?.employment_occupation, kycData?.employment_jobTitle].filter(Boolean).join(" — "),
        cramOccupationOptions,
      ),
      build(
        "industry",
        mapping?.industry,
        [kycData?.employment_industry_type, kycData?.employment_employer].filter(Boolean).join(" — "),
        cramIndustryOptions,
      ),
    ];
  })();

  const cramMappingNeedsAttention = cramMappingRows.some((r) => r.needsAttention);

  // The card used to disappear when no mapping (or no employment text) existed,
  // which reads as "nothing to do here" when the truth is that the AI never ran
  // and CR has an unmapped KYC. It is now always rendered for CR / admin, so
  // the gap is always visible and always fixable.
  const showCramMappingCard = !!(userClaims.cr || userClaims.admin) && !isMinorKyc;
  // Re-runnable while either target is still unconfirmed — a run that returned
  // nothing usable is exactly when another attempt is wanted. Admin-only,
  // because each run can spend AI budget. The callable enforces the same.
  const canCallCramAiMapping =
    !!userClaims.admin && cramMappingRows.some((r) => !r.resolved);

  // The CRAM group owns the rating: they see the score, and they are the only
  // ones who can pin it (cramRiskOverride enforces the same claim server-side).
  const isCramTeam = !!(userClaims.cram || userClaims.admin);

  // Once a KYC is approved its fields are locked: they back a signed record and
  // drive a live CRAM rating, so only the CRAM group may still correct them.
  // One boolean, passed to every editable card on this page and to the PEP
  // button, so there is a single place the lock is decided.
  const kycEditsLocked =
    kycData?.state?.status_code === "valid" && !userClaims.cram;

  // Activation gate — mirror shared-helpers isKycWithinCramActivation so the UI
  // treats a KYC as CRAM-operational only when it is on/after the configured
  // activation date. The backend derives tags/validation from CRAM only when
  // (live && within-activation); using bare `isCramLive` for display/gates would
  // show CRAM as authoritative and hide legacy controls while the backend is
  // still on legacy risk (e.g. an activation date introduced after shadow
  // snapshots already exist).
  const cramWithinActivation = (() => {
    const toMillis = (raw: any): number | null => {
      if (raw === null || typeof raw === "undefined" || raw === "") return null;
      if (typeof raw === "number") return Number.isFinite(raw) ? raw : null;
      if (raw && typeof raw.toMillis === "function") return raw.toMillis();
      if (raw && typeof raw.toDate === "function") return raw.toDate().getTime();
      if (raw instanceof Date) return raw.getTime();
      const parsed = Date.parse(String(raw));
      return Number.isNaN(parsed) ? null : parsed;
    };
    const activationMs = toMillis(appConfig?.cram?.activationDate);
    if (activationMs === null) return true;
    const kycMs = toMillis((kycData as any)?.created ?? (kycData as any)?.submittedAt);
    const effective = kycMs === null ? Date.now() : kycMs;
    return effective >= activationMs;
  })();
  // Audience gate — mirror shared-helpers getCramCustomerKind /
  // isCramAudienceEnabledForCustomer so the UI matches the backend: company and
  // trust customers are only CRAM-bound when their audience flag is on;
  // individuals are always in scope.
  const cramAudienceEnabled = (() => {
    const audience = appConfig?.cram?.audience;
    const isTrust = customerData?.customerType === "trust";
    const isCompany =
      customerData?.customerType === "company" ||
      !!customerData?.commercial_register?.trim();
    if (isTrust) return !!audience?.enabledForTrust;
    if (isCompany) return !!audience?.enabledForCorporate;
    return true;
  })();
  // CRAM is authoritative for this KYC only when live AND within activation AND
  // enabled for this customer's kind AND the KYC is not a minor's. Used for
  // every operational display/gate below.
  const isCramLiveEffective =
    isCramLive && cramWithinActivation && cramAudienceEnabled && !isMinorKyc;

  // Hard-block review/approve until the CRAM mapping is resolved. This applies
  // in EVERY CRAM mode (shadow / off / live): as long as an AI mapping exists
  // and still needs attention, it must be confirmed before the KYC advances. An
  // AI mapping is only ever produced when CRAM computes for an audience-enabled
  // kind, so disabled company/trust customers have none and are unaffected. Only
  // applies for the roles (CR/admin) that can see and resolve the mapping card
  // below — otherwise a non-CR approver would be blocked with no way to fix it.
  // Resolving the mapping is a CR-review responsibility, so the selling-agent
  // review step (RM operations / kfh_rm_approver, action "selling_agent_review")
  // is exempted at the button below. The same invariant is enforced server-side
  // in kycAction (functions/src/index.ts) for the review/approve actions only.
  const cramMappingUnresolved =
    !!kycData?.aiMapping &&
    cramMappingNeedsAttention &&
    !isMinorKyc &&
    (userClaims.cr || userClaims.admin);

  // Prohibited customers cannot be reviewed or approved — the case must be
  // rejected. Blocks the review/approve action in live only (shadow is view-only)
  // and surfaces the reasons next to the button. Also enforced server-side.
  // A CRAM-team override replaces the engine rating everywhere, including
  // here — lifting the block is exactly what an override off Prohibited is
  // for. Mirrors cramHelper.resolveEffectiveCramRating on the server.
  const cramOverride = kycData?.cramOverride;
  const effectiveCramRating = cramOverride?.rating ?? kycData?.cram?.rating;
  const cramProhibited =
    !!kycData?.cram && isCramLiveEffective && effectiveCramRating === "Prohibited";
  const cramProhibitedReasons = cramOverride
    ? [`CRAM override: ${cramOverride.reason}`]
    : kycData?.cram?.prohibitedReasons || [];

  // A live+activated KYC with no computed CRAM snapshot means the engine failed
  // at submit (the submit path swallows CRAM errors). Block review/approve so
  // the KYC isn't advanced without a CRAM assessment — mirrors the server guard
  // in kycAction. The selling-agent step and reject/needs_update stay allowed,
  // and the CR can recompute CRAM to clear it.
  const cramSnapshotMissing =
    isCramLiveEffective && !kycData?.cram && (userClaims.cr || userClaims.admin);

  // Reusable CRAM rating summary — used inline in the merged card (live) and
  // standalone (shadow). `viewOnly` adds the "does not affect risk" badge.
  const renderCramRatingBody = (opts: { viewOnly: boolean }) => {
    const cram = kycData?.cram;
    if (!cram) return null;
    return (
      <>
        <Center>
          {/* `align="center"` matters: without it the Stack stretches its
              children, so the rating badge goes full-width (reading as
              left-aligned) as soon as the override line widens the card. */}
          <Stack align="center" ta="center" gap={6}>
            <Group gap={6} wrap="nowrap" justify="center">
              <Badge size="lg" color={cramRatingColor(effectiveCramRating)}>
                {effectiveCramRating}
              </Badge>
              {/* Full override audit trail behind the same orange (i) icon used
                  for edited KYC fields, so the card itself stays a one-line
                  statement of the rating. */}
              {cramOverride && (
                <Tooltip
                  bg="white"
                  withArrow
                  label={
                    <Card withBorder>
                      <Text c="black">
                        Calculated Risk :{" "}
                        <Text span c="blue" inherit>{cramOverride.fromRating}</Text>
                      </Text>
                      <Text c="black">
                        Overridden Risk :{" "}
                        <Text span c="blue" inherit>{cramOverride.rating}</Text>
                      </Text>
                      <Text c="black">
                        Overridden By :{" "}
                        <Text span c="blue" inherit>
                          {cramOverride.byName || cramOverride.byEmail || cramOverride.byUid}
                        </Text>
                      </Text>
                      <Text c="black">
                        Overridden On :{" "}
                        <Text span c="blue" inherit>{formatDateValue(cramOverride.at)}</Text>
                      </Text>
                      <Text c="black">
                        Reason : <Text span c="blue" inherit>{cramOverride.reason}</Text>
                      </Text>
                    </Card>
                  }
                >
                  <ThemeIcon variant="transparent" color="orange" size="sm">
                    <IconAlertCircle size={15} />
                  </ThemeIcon>
                </Tooltip>
              )}
            </Group>
            {cramOverride && (
              <Text size="xs" c="dimmed">
                Overridden — calculated risk is {cram.rating}
              </Text>
            )}
            {isCramTeam && (
              <Text c="dimmed" size="sm">Score: {cram.score}</Text>
            )}
            {opts.viewOnly && (
              <Badge variant="light" color="gray" size="sm">
                View only — does not affect customer risk
              </Badge>
            )}
          </Stack>
        </Center>

        {/* Engine reasons are hidden while an override holds: they explain a
        rating that is no longer in effect, and showing them next to the
        overridden badge reads as justification for it. */}
        {!cramOverride && cram.prohibitedReasons?.length > 0 && (
          <>
            <Divider my="sm" label="Prohibited reasons" labelPosition="left" />
            <Stack gap={4}>
              {cram.prohibitedReasons.map((r, i) => (
                <Text key={`pr-${i}`} size="sm" c="red" fw={600}>• {r}</Text>
              ))}
            </Stack>
          </>
        )}

        {isCramTeam && (
          <>
            <Space h="sm" />
            <Group justify="center" gap="xs" wrap="nowrap">
              {cram.breakdown && (
                <Button
                  size="xs"
                  variant="light"
                  color="grape"
                  leftSection={<IconListDetails size={16} />}
                  onClick={() => setCramBreakdownOpen(true)}
                >
                  Breakdown
                </Button>
              )}
              <Button
                size="xs"
                variant="light"
                color="orange"
                leftSection={<IconArrowsLeftRight size={16} />}
                onClick={() => setCramOverrideMode("apply")}
              >
                Override
              </Button>
              {cramOverride && (
                <Button
                  size="xs"
                  variant="light"
                  color="red"
                  leftSection={<IconMinus size={16} />}
                  onClick={() => setCramOverrideMode("remove")}
                >
                  Remove override
                </Button>
              )}
            </Group>
          </>
        )}
      </>
    );
  };

  // Napier screening of THIS KYC. Rendered for every KYC, including a minor's: the minor is
  // screened in their own name and approval requires each of their hits to be reviewed, so the
  // CR must be able to see (and re-run) them next to the guardian's screening.
  const amlScreeningPanel = data ? (
    <Paper shadow="xs" p="md">
      <Group justify="space-between" wrap="nowrap" style={{ width: '100%' }}>
        <ThemeIcon color="red" variant="light">
          <IconSearch size={16} />
        </ThemeIcon>
        <Title order={5} style={{ textAlign: 'left', width: '100%' }}>AML Screening</Title>
        <ActionIcon
          loading={loadingAML}
          variant="subtle"
          onClick={async () => {
            try {
              setAMLLoading(true); // Start loading spinner

              const napierConnect = httpsCallable(functions, "napierScreening");

              const civilID = data?.civilID || '';
              const kycID = KYCDoc?.id || '';
              const customerID = customerData.id || '';

              // Check if the customer and kycID are known
              if ((!civilID.trim() && !customerID) || !kycID.trim()) {
                notifications.show({
                  title: 'Missing Data',
                  message: 'Civil ID or KYC ID is missing.',
                  color: 'red',
                });
                return;
              }

              // Run English Screening (the customer, plus their submission parties: authorized signatories / guardian)
              const englishBody = { civilID, kycID, customerID, isArabic: false };
              console.log("[NAPIER] screening request:", englishBody);

              const resEn: any = await napierConnect(englishBody);
              const englishSuccess = resEn?.data?.status === "screening_success";

              notifications.show({
                title: englishSuccess ? 'Screening Success' : 'Screening Failed',
                message: englishSuccess ? 'screening completed successfully.' : (resEn?.data?.message || 'Unknown error during English screening.'),
                color: englishSuccess ? 'green' : 'red',
              });



            } catch (err: any) {
              notifications.show({
                title: 'Unexpected Error',
                message: err?.message || err || 'Something went wrong.',
                color: 'red',
              });
            } finally {
              setAMLLoading(false); // Always stop loading
            }

          }}
        >
          <ThemeIcon color="blue" variant="light">
            <IconRefresh size={16} />
          </ThemeIcon>
        </ActionIcon>
      </Group>
      <Space h="xs" />
      <Space h="xs" />
      <NapierAmlScreeningView
        kycData={data}
        customerID={customerData.id!}
        originalSubmittedAt={originalSubmittedAt}
      />

    </Paper>
  ) : null;

  return (
    <>
      <MyUserDataContext.Consumer>
        {(userData: any) => {
          return (
            <>
              <Modal
                opened={confirmDialog != null}
                onClose={() => {
                  setConfirmDialog(null);
                  setConfirmDialogError(null);
                }}
                title={<Title order={3}>{confirmDialog?.title}</Title>}
              >
                <form
                  onSubmit={form.onSubmit(async (values) => {
                    setConfirmDialogError(null);
                    setConfirming(true);
                    try {
                      await confirmDialog?.callback(values);
                      setConfirmDialog(null);
                    } catch (error: any) {
                      setConfirmDialogError(error.message);
                    }
                    setConfirming(false);
                  })}
                >
                  <Stack>
                    <Text fw={300}>{confirmDialog?.description}</Text>
                    {/* <Space h="xl"/> */}
                    {confirmDialog?.textField && (
                      <>
                        <Text>{confirmDialog?.textFieldDescription}</Text>
                        <TextInput
                          {...form.getInputProps(confirmDialog.textField)}
                        />
                      </>
                    )}

                    <Group>

                      <Button
                        color={confirmDialog?.buttonColor}
                        type="submit"
                        loading={confirming}
                      >
                        {confirmDialog?.action}
                      </Button>
                      {confirmDialog?.extraActions}
                    </Group>

                    {confirmDialogError && (
                      <Alert
                        icon={<IconAlertCircle size={16} />}
                        title="Whoops!"
                        color="red"
                      >
                        {confirmDialogError}
                      </Alert>
                    )}
                  </Stack>
                </form>
              </Modal>

              {cramOverrideMode && KYCDoc && (
                <CramOverrideModal
                  mode={cramOverrideMode}
                  onClose={() => setCramOverrideMode(null)}
                  customerID={customerData.id!}
                  kycID={KYCDoc.id}
                  engineRating={kycData?.cram?.rating}
                  overriddenRating={cramOverride?.rating}
                />
              )}
              {/* 
              <Modal
                opened={manualEntryDialog != null}
                onClose={() => {
                  setManualEntryDialog(null);
                  setConfirmDialogError(null);
                }}
              // title={<Title order={3}>{confirmDialog?.title}</Title>}
              >
                <form
                  onSubmit={manualEntryForm.onSubmit(async (entries) => {
                    // console.log(values);
                    // event.preventDefault()

                    setConfirmDialogError(null);
                    setConfirming(true);

                    let civilID = customerData.civilID;

                    //get birthdate from civil ID
                    let date = civilID.match(
                      /(\d{1})(\d{2})(\d{2})(\d{2})\d{5}/
                    )!;  //if it dies, it dies.


                    const n = 17 + Number(date[1]) + "" + date[2];

                    const dateObj = new Date(
                      Number(n),
                      Number(date[3]) - 1,
                      Number(date[4]),
                    );
                    console.log(dateObj);


                    let d = {
                      ...entries,
                      birthDate: dateObj,
                      name_en: customerData.name_en,
                      name_ar: customerData.name_ar,
                      civilID: civilID,
                    };

                    //validate!
                    if (overrideCivilID) {
                      if (
                        d.civilIDExpiryDate?.length === 0 ||
                        d.houseID?.length === 0 ||
                        d.gender?.length === 0 ||
                        d.nationality?.length === 0
                      ) {
                        await setConfirming(false);
                        setConfirmDialogError("Please fill out all fields!");
                        console.log("FAIL!");
                        return;
                      }
                      d.overrideCivilID = true
                    } else {
                      //remove it from the D
                      delete d.civilIDExpiryDate;
                      delete d.houseID;
                      delete d.birthDate;
                      delete d.name_en;
                      delete d.name_ar;
                      delete d.gender;
                      delete d.nationality;
                      delete d.civilID;
                    }

                    if (overridePassport) {
                      if (
                        d.passportNumber?.length === 0 ||
                        d.passportExpiryDate?.length === 0
                      ) {
                        setConfirming(false);
                        setConfirmDialogError("Please fill out all fields!");
                        console.log("FAIL!");
                        return;
                      }
                      d.overridePassport = true

                    } else {
                      //remove it from the D
                      delete d.passportNumber;
                      delete d.passportExpiryDate;

                    }

                    // if (d.civilIDExpiryDate) d.civilIDExpiryDate = parseDayFirst(d.civilIDExpiryDate);
                    // if (d.passportExpiryDate) d.passportExpiryDate = parseDayFirst(d.passportExpiryDate);
                    if (d.nationality)
                      d.nationality = COUNTRY_CODES[d.nationality];

                    console.log("d", d);

                    //submit to firebase

                    showNotification({
                      id: "overridingKYC",
                      loading: true,
                      message: `Overriding KYC for ${customerData.civilID}`,
                      // message: 'Data will be loaded in 3 seconds, you cannot close this yet',
                      autoClose: false,
                      // disallowClose: true,
                    });

                    oneTimeOverrideKYC({ kycData: d, customerID: customerData?.civilID })
                      .then((res) => {
                        console.log("res", res);
                        setConfirming(false);
                        setManualEntryDialog(null);

                        updateNotification({
                          id: "overridingKYC",
                          color: "teal",
                          // title: 'SMS Sent',
                          // message: 'SMS was sent to customer',
                          message: ` KYC Overriden ${customerData.civilID}`,
                          icon: <IconCheck size={16} />,
                          autoClose: 4000,
                        });
                      })
                      .catch((err) => {
                        setConfirming(false);

                        updateNotification({
                          id: "overridingKYC",
                          color: "red",
                          // title: 'SMS Sent',
                          title: `Couldn't override ${customerData.civilID}`,
                          message: `${err}`,
                          icon: <IconCheck size={16} />,
                          autoClose: 4000,
                        });

                        console.log("err", err);
                      });

                    // closeAllModals();
                  })}
                >
                  <Checkbox
                    label="Override Civil ID"
                    checked={overrideCivilID}
                    onChange={(e) => setOverrideCivilID(e.target.checked)}
                  />

                  <Select
                    label="Nationality"
                    placeholder="Pick one"
                    name="nationality"
                    searchable
                    nothingFoundMessage="No options"
                    withAsterisk
                    disabled={!overrideCivilID}
                    {...manualEntryForm.getInputProps("nationality")}
                    // onChange={(val) => manualE({...manualEntryData, nationality: val})}
                    data={Object.keys(COUNTRY_CODES).map((val) => {
                      return { value: val, label: val };
                    })}
                  />

                  <Radio.Group
                    name="gender"
                    label="Gender"
                    withAsterisk
                    {...manualEntryForm.getInputProps("gender")}
                  >
                    <Radio value="M" label="Male" disabled={!overrideCivilID} />
                    <Radio
                      value="F"
                      label="Female"
                      disabled={!overrideCivilID}
                    />
                  </Radio.Group>

                  <TextInput
                    label="House ID"
                    name="houseID"
                    withAsterisk
                    placeholder=""
                    disabled={!overrideCivilID}
                    // onChange={(event) => {console.log(manualEntryData, event.currentTarget.value); setManualEntryData({houseID: event.currentTarget.value})}}

                    {...manualEntryForm.getInputProps("houseID")}
                  />

                  <DateInput

                    locale="en-gb"

                    dateParser={parseDayFirst}
                    label="Civil ID Expiry"
                    name="civilIDExpiryDate"
                    placeholder="Pick date"
                    valueFormat="DD/MM/YYYY"
                    disabled={!overrideCivilID}
                    {...manualEntryForm.getInputProps("civilIDExpiryDate")}
                  />

                  <Space h="xl" />
                  <Checkbox
                    label="Override Passport"
                    checked={overridePassport}
                    onChange={(e) => setOverridePassport(e.target.checked)}
                  />

                  <TextInput
                    label="Passport Number"
                    name="passportNumber"
                    placeholder=""
                    disabled={!overridePassport}
                    {...manualEntryForm.getInputProps("passportNumber")}
                  />

                  <DateInput
                    locale="en-gb"
                    dateParser={parseDayFirst}

                    label="Passport Expiry"
                    name="passportExpiryDate"
                    placeholder="Pick date"
                    valueFormat="DD/MM/YYYY"
                    disabled={!overridePassport}
                    {...manualEntryForm.getInputProps("passportExpiryDate")}
                  />

                  <Space h="xl" />
                  <Button color="red" type="submit" loading={confirming}>
                    Submit
                  </Button>

                  {confirmDialogError && (
                    <Alert
                      icon={<IconAlertCircle size={16} />}
                      title="Whoops!"
                      color="red"
                    >
                      {confirmDialogError}
                    </Alert>
                  )}
                </form>
              </Modal> */}
            </>
          );
        }}
      </MyUserDataContext.Consumer>

      <Space h="md" />

      {showIdentityHeader && (showButton ?? false) && !(hideHeaderButton ?? false) && (<Group>
        <ActionIcon onClick={() => {
          //go back
          navigate("/customers");
        }}>
          <IconArrowLeft size="3rem" />
        </ActionIcon>
        {data && (
          <Title>
            {data!.name_en}
          </Title>
        )}
      </Group>)}
      <Group justify="space-between">
        {!(hideHeaderButton ?? false) && (
          <MyUserDataContext.Consumer>
            {(value: any) => (
              <Group mt={20}>
                {/* show Create AMS Account button only in case where showGeneratePDF is true  and customer does not have tradex id */}
                {(showGeneratePDF || userClaims.oper || userClaims.admin) &&

                  <Button
                    color="pink"
                    loading={pendingCreateAMS}
                    disabled={customerData?.tags?.kycStatus?.code !== "valid" && false}
                    type="button"
                    name="create_account"
                    onClick={async () => {
                      //send API request to create AMS
                      setPendingCreateAMS(true);
                      try {
                        // console.log("Creating AMS account with data", customerData, data);
                        let res = await createAMSAccount({ customer: customerData, kyc: data });

                        console.log("Result from createAMS", res);
                      } catch (error: any) {
                        showNotification({
                          id: "error",
                          color: "red",
                          icon: <IconX />,
                          withBorder: true,
                          // loading: true,
                          message: `Error creating account: ${error.message}`,
                          // message: 'Data will be loaded in 3 seconds, you cannot close this yet',
                          // autoClose: true,
                          // disallowClose: true,
                        });

                      }
                      setPendingCreateAMS(false);

                    }}
                  >
                    Create AMS account
                  </Button>
                }
                {/*
              <Button
                color="orange"
                disabled={customerData?.tags?.kycStatus?.code !== "valid"}
                type="button"
                name="create_account"
              >
                Create KFH Trade account
              </Button> */}



                {showGeneratePDF && (!customerData.employee || userClaims.hr === true) &&
                  <Button
                    color="violet"
                    loading={pending}
                    type="button"
                    name="addRow"
                    onClick={() => setGeneratePDFOpen(true)}
                  >
                    Generate KYC PDF
                  </Button>
                }


                {
                  canSendPromotionalMaterial && (userClaims?.admin || userClaims?.cr) && <Button
                    color="teal"
                    loading={pending}
                    type="button"
                    name="addRow"
                    onClick={() => setPromotionalMaterialModalOpen(true)}
                  >
                    Send promotional material
                  </Button>
                }

                {(userClaims.admin || userClaims.cr) &&
                  <Button
                    color="blue"
                    loading={pending}
                    type="button"
                    name="addFamilyMember"
                    onClick={() => setFamilyMemberModalOpen(true)}
                  >
                    Family members
                  </Button>
                }

                {(userClaims.admin || userClaims.cr) &&
                  <Button
                    color="orange"
                    loading={pendingManualKYC}
                    // KYC links require a civil ID or other ID (individuals) or commercial register (companies)
                    disabled={!customerData?.civilID && !customerData?.other_id?.trim() && !customerData?.commercial_register?.trim()}
                    type="button"
                    name="createManualKYC"
                    onClick={async () => {
                      setPendingManualKYC(true);
                      try {
                        const res = await createContractUserKYCLink({ customerID: customerData.id, manual: true });
                        const linkID = res.data?.data?.linkID;
                        showNotification({
                          id: "createManualKYC",
                          color: "teal",
                          icon: <IconCheck size={16} />,
                          message: `Manual KYC link ${linkID ?? ""} created. It is listed under Active links — no message was sent to the customer.`,
                          autoClose: 6000,
                        });
                      } catch (error: any) {
                        showNotification({
                          id: "createManualKYC",
                          color: "red",
                          icon: <IconX />,
                          withBorder: true,
                          message: `Error creating manual KYC: ${error.message}`,
                        });
                      }
                      setPendingManualKYC(false);
                    }}
                  >
                    Create Manual KYC
                  </Button>
                }

              </Group>
            )}


          </MyUserDataContext.Consumer>
        )}

        <Stack>
          {showIdentityHeader && (
            <Text c={"blue"} fw={"bold"}>CIF: {customerData?.crmID}</Text>
          )}

          {showKycVersion &&
            <>
              <Select
                searchable
                allowDeselect={false}
                label="KYC Version "
                data={kycDocs?.docs.map((kycObj) => {

                  const purpose = summarizeKycPurpose(describeKycPurpose({
                    kyc: { ...kycObj.data(), id: kycObj.id },
                    customerID: customerData?.id,
                    productsByKyc: kycProductsByKyc,
                    links: kycLinks,
                    olderKycExists: kycID ? undefined : olderKycExistsFor(kycObj.id),
                  }));
                  return { ...kycObj, label: `${formatDateValue(kycObj.data().created)}${purpose ? ` · ${purpose}` : ""}`, value: kycObj.id }
                })}
                value={KYCDoc?.id}
                onChange={(chosenKycID) => {
                  const chosenKyc = kycDocs!.docs.find((kyc) => kyc.id === chosenKycID);

                  if (chosenKyc) {
                    selectKycDoc(chosenKyc as QueryDocumentSnapshot<KYC>);
                    navigate(`?kyc=${chosenKycID}`, { replace: true });
                  }

                }}

              >


              </Select>
              <Text>ID: {KYCDoc?.id}</Text>
            </>
          }
          {KYCDoc && <KycPurposeBadges items={kycPurposeItems} compact={!showKycVersion} />}
        </Stack>
      </Group>

      {guardianKyc && guardianCustomer && (
        <>
          <Space h="md" />
          <Accordion
            multiple
            variant="contained"
            transitionDuration={200}
            value={openAccordions}
            classNames={{ item: classesGuardian.item, control: classesGuardian.control, panel: classesGuardian.panel }}
            onChange={setOpenAccordions}
          >
            <Accordion.Item key="guardian_kyc" value="guardian_kyc">
              <Accordion.Control>
                <Group justify="space-between" wrap="nowrap" pr="sm">
                  <Group gap="sm" wrap="nowrap">
                    <ThemeIcon variant="light" color="grape" size="lg" radius="md">
                      <IconUserShield size={18} />
                    </ThemeIcon>

                    <Stack gap={2}>
                      <Group gap={8} wrap="nowrap">
                        <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
                          Guardian KYC ({guardianKyc.beneficiaryInformation?.[0]?.relation ?? '-'})
                        </Text>
                        <Badge
                          size="sm"
                          variant="light"
                          color={
                            guardianKyc?.state?.status_code
                              ? tagsByCode[guardianKyc.state.status_code]?.badgeColor ?? 'gray'
                              : 'gray'
                          }
                        >
                          {guardianKyc.state?.status_code}
                        </Badge>
                      </Group>
                      <Group gap="xs" wrap="nowrap">
                        <Text fw={600} size="sm">
                          {guardianCustomer.name_en ?? '—'}
                        </Text>
                      </Group>
                    </Stack>
                  </Group>
                  <Text fw={600} size="sm">
                    KYC ID: {guardianKyc.id ?? '—'}
                  </Text>
                </Group>
              </Accordion.Control>

              <Accordion.Panel>
                <CustomerKYC
                  key={`${guardianKyc.id}-${guardianCustomer.civilID}`}
                  metaTypes={metaTypes}
                  setMetaTypes={setMetaTypes}
                  disableUpload={guardianKyc.state?.status_code === 'rejected'}
                  customerData={guardianCustomer}
                  showButton={true}
                  kycID={guardianKyc.id}
                  showActiveLinks={false}
                  hideHeaderButton={true}
                  showKycVersion={false}
                  showGeneratePDF={false}
                />
              </Accordion.Panel>
            </Accordion.Item>
          </Accordion>
          <Space h="md" />
        </>
      )}

      <Group justify="flex-start" >
        {guardianKyc && guardianCustomer && (
          <>
            <div style={{ height: 1, background: 'var(--mantine-color-gray-3)', width: '100%' }} />
            <Title order={3}>Minor Customer Details</Title>
          </>
        )}
      </Group>




      <MyUserDataContext.Consumer>
        {(userData: any) => {
          return (
            <>
              {kycLinks && kycLinks.filter(isActiveKycLink).length > 0 && (showActiveLinks ?? true) && !(hideHeaderButton ?? false) && (
                <Paper shadow="xs" p="md">
                  <Group>
                    <ThemeIcon variant="light">
                      <IconEye size={16} />
                    </ThemeIcon>
                    <Title order={5}>Active links</Title>
                  </Group>
                  <Space h="xs" />

                  <>
                    {/* Most cases have accept_terms, but Entity KYC 1st link doesn't — so we also check status to filter out completed/cancelled links */}
                    {kycLinks.filter(isActiveKycLink).map((link, idx) => {

                      //TODO: use this to have admin privileges and skip steps for KYC
                      let userID = `?user=${userData?.msal?.uniqueId}`;

                      return <CustomerKycLinks userID={userID} userData={userData} kycStatus={customerData.tags?.kycStatus?.code} link={link} idx={idx} key={idx} />

                    })}
                  </>


                </Paper>)
              }

            </>

          );
        }}
      </MyUserDataContext.Consumer>

      <Space h="xl" />

      {/* minor_* fields live on the guardian's KYC — the guardian fills them in about the child, Here not any Editable data */}
      {guardianKyc && data && (
        <MinorInfoCard
          kyc={data}
          itemDoc={KYCDoc}
          updatedItemData={updatedKYCData}
        >
          {/* The minor is screened in their own name: their hits must be reviewed before approval */}
          {amlScreeningPanel}
        </MinorInfoCard>
      )}

      {data && !guardianKyc && (
        <SimpleGrid cols={3}>
          <EditableInfoCard<KYC>
            editsLocked={kycEditsLocked}
            updatedItemData={updatedKYCData}
            title="Client Information"
            color="blue"
            icon={<IconPhone size={16} />}
            itemDoc={KYCDoc}
            list={[
              {
                label: "Name (en)",
                value: data.name_en,
              },

              {
                label: "Name (ar)",
                value: data.name_ar,
              },
              {
                label: "Civil ID",
                value: data.civilID,
              },
              {
                label: "Civil ID Expiry",
                value: formatDateValue(data.civilIDExpiryDate)
              },
              {
                label: "Birth Date",
                editable: userClaims["cr"],
                value: formatDateValue(data.birthDate),
                fieldName: "birthDate",
                componentType: "Timestamp"
              },
              {
                label: "Mobile",
                value: data.mobile,
              },
              {
                label: "Nationality",
                value: data!.nationality,
              },
              {
                label: "Gender",
                value: data!.gender,
              },
              {
                label: "Place of birth",
                value: data.placeOfBirth,
              },
              {
                label: "House ID",
                value: data.houseID,
                noCapitalize: true,
              },
              {
                label: "Country of residence",
                value: data.residence ? (countryMap[data.residence] ?? data.residence) : undefined,
              },
              ...(isEntityKycCustomer(customerData) ? [] : [
                {
                  label: "PACI Nationality (ar)",
                  value: data!.paciData?.PersonalData?.NationalityAr || undefined,
                },
                {
                  label: "PACI Nationality (en)",
                  value: data!.paciData?.PersonalData?.NationalityEn || undefined,
                },
                {
                  label: "PACI Sponsor",
                  value: data.paciData?.PersonalData?.GovData?.SponsorName || undefined
                },
                {
                  label: "PACI Mobile",
                  value: data.paciData?.PersonalData?.MobileNumber || undefined
                },
                {
                  label: "PACI Email",
                  value: data.paciData?.PersonalData?.EmailAddress || undefined,
                  noCapitalize: true,
                },
              ]),
              {
                label: "Passport Name",
                value: customerData?.passportData?.fullName
              },
              {
                label: "Passport ID",
                value: customerData?.passportData?.id
              },
              {
                label: "Passport Expiry Date",
                value: formatDateValue(customerData?.passportData?.expiryDate)
              },
              {
                label: "Address (en)",
                value: data?.address?.DetailsEnglish,
              },

              {
                label: "Address (ar)",
                value: data?.address?.DetailsArabic,
              },
              {
                label: "PACI Address",
                value: data?.address_from_finder?.DetailsEnglish
              },
              {
                label: "Address",
                value: data?.address ? getAddressDetailsEnglish(data?.address) : null,
              },
              // ...Object.keys(data?.address).map((key) => {return {label: key, value: data?.address[key]}} )
            ]}
          />

          {((customerData.employee && userClaims.hr) || !customerData.employee) && <EditableInfoCard<KYC>
            editsLocked={kycEditsLocked}
            updatedItemData={updatedKYCData}
            title="Income Information"
            color="red"
            icon={<IconWallet size={16} />}
            itemDoc={KYCDoc}
            list={[
              // if commercial register exists, show sourcesOfIncomeEntity with text input
              ...(isEntityKycCustomer(customerData)
                ? [{
                  label: "Sources of Income (Entity)",
                  editable: userClaims["cr"],
                  value: data.sourcesOfIncomeEntity || "",
                  fieldName: "sourcesOfIncomeEntity" as keyof KYC,
                  componentType: "TextInput" as EditableComponentType,
                }]
                : []),
              // if commercial register does not exist, show sourcesOfIncome with multi select
              ...(!isEntityKycCustomer(customerData)
                ? [{
                  label: "Sources of Income",
                  editable: userClaims["cr"],
                  value: printArrayWithOthers("sourcesOfIncome"),
                  dataOptions: translateArrayObj(
                    KYCDoc?.data()?.completedKYCData && KYCDoc?.data()?.completedKYCData?.id
                      ? [...newSourcesOfIncome] // Show NEW when completedKYCData exists
                      : [...sourcesOfIncome]    // Show OLD when completedKYCData is null/undefined
                  ),
                  fieldName: "sourcesOfIncome" as keyof KYC,
                  componentType: "MultiSelect" as EditableComponentType,
                }]
                : []),
              {
                label: "Sources of Wealth",
                editable: userClaims["cr"],
                value: printArrayWithOthers("sourcesOfWealth"),
                dataOptions: translateArrayObj(
                  KYCDoc?.data()?.completedKYCData && KYCDoc?.data()?.completedKYCData?.id
                    ? [...newSourcesOfWealth] // Show NEW when completedKYCData exists
                    : [...sourcesOfWealth]    // Show OLD when completedKYCData is null/undefined
                ),
                fieldName: "sourcesOfWealth",
                componentType: "MultiSelect",
              },
              {
                label: "Average annual income (KD)",
                editable: userClaims["cr"],
                value: toKwd(data.averageAnnualIncome),
                dataOptions: translateArrayObj(averageAnnualIncome),
                fieldName: "averageAnnualIncome",
                componentType: data.completedKYCData ? "NumberInput" : "Select",
              },
              {
                label: "Approximate wealth (KD)",
                editable: userClaims["cr"],
                value: toKwd(data.approximateWealth),
                dataOptions: translateArrayObj(approximateWealth),
                fieldName: "approximateWealth",
                componentType: data.completedKYCData ? "NumberInput" : "Select",
              },
              {
                label: "Total wealth & annual income (KD)",
                value: (data.approximateWealth || data.averageAnnualIncome)
                  ? toKwd(String(Number(String(data.approximateWealth || 0).replace(/,/g, "")) + Number(String(data.averageAnnualIncome || 0).replace(/,/g, ""))))
                  : undefined,
              },
              // New (contract) KYC income breakdown: annual income = (monthly salary * 12) + bonuses
              ...(isNewContractKyc ? [
                {
                  label: "Monthly salary (KD)",
                  value: toKwd(data.sourcesOfMonthlySalary),
                  fieldName: "sourcesOfMonthlySalary" as keyof KYC,
                },
                {
                  label: "Bonuses & other amounts (KD)",
                  value: toKwd(data.sourcesOfBonusesAndOtherAmounts),
                  fieldName: "sourcesOfBonusesAndOtherAmounts" as keyof KYC,
                },
              ] : []),
              {
                label: "Source of income details",
                value: data.sourceOfIncomeSentence,
                fieldName: "sourceOfIncomeSentence" as keyof KYC,
              },
              {
                label: "Source of wealth details",
                value: data.sourceOfWealthSentence,
                fieldName: "sourceOfWealthSentence" as keyof KYC,
              },
            ]}
          />}
          {customerData.employee && !userClaims.hr && (
            <Paper shadow="xs" p="md" pos="relative" style={{ overflow: "hidden" }}>
              <Group>
                <ThemeIcon color="red" variant="light"><IconWallet size={16} /></ThemeIcon>
                Income Information
              </Group>
              <Space h="xs" />
              {/* placeholder rows, blurred so the card keeps its shape without exposing anything */}
              <Stack gap={6} style={{ filter: "blur(4px)", userSelect: "none" }} aria-hidden>
                {["Sources of Income", "Sources of Wealth", "Average annual income (KD)", "Approximate wealth (KD)"].map((label) => (
                  <Group key={label} justify="space-between">
                    <Text size="sm" c="dimmed">{label}</Text>
                    <Text size="sm" fw={500}>••••••••</Text>
                  </Group>
                ))}
              </Stack>
              <Center pos="absolute" inset={0}>
                <Badge size="lg" color="orange" variant="filled" leftSection={<IconUserShield size={14} />}>
                  Employee KYC: financial info restricted to HR
                </Badge>
              </Center>
            </Paper>
          )}
          { /* Company KYC no need Photo here */}
          {!isEntityKycCustomer(customerData) && data!.photo && (
            <ImageViewCard photo={data?.photo} title="Photo" h={200} w="auto" />
          )}
          <EditableInfoCard<KYC>
            editsLocked={kycEditsLocked}
            title="Investment Information"
            color="green"
            itemDoc={KYCDoc}
            updatedItemData={updatedKYCData}
            icon={<IconShoppingCart size={16} />}
            list={[
              {
                label: "Investment experience",
                value: printArrayWithOthers("investmentExperience"),
                fieldName: "investmentExperience",
              },
              {
                label: "Investment awareness",
                value: data!.investmentAwareness,
                fieldName: "investmentAwareness",
              },
              {
                label: "Investment objectives & strategy",
                value: printArrayWithOthers("investmentObjectives"),
                fieldName: "investmentObjectives",
              },
              {
                label: "Appetite of risk",
                value: data!.riskAppetite,
                fieldName: "riskAppetite",
              },
              {
                label: "Requested investment asset class",
                value: printArrayWithOthers("requestedAssetClass"),
                fieldName: "requestedAssetClass",
              },

              {
                label: "Invested amount",
                value:
                  <>
                    {data.investedAmountOfWealth} %
                  </>
                ,
                fieldName: "investedAmountOfWealth",
                editable: userClaims["cr"],
                componentType: "Select",
                dataOptions: translateArrayObj(investedAmountOfWealth),
                rightSection: <>%</>,
              },
              {
                label: "Expected activity",
                value: data!.expectedVolume,
                fieldName: "expectedVolume",
              },
              {
                label: "Risk tolerance",
                value: data.riskTolerance?.length ? data.riskTolerance.join(", ") : undefined,
                fieldName: "riskTolerance",
              },
              {
                label: "Sub portfolio reason",
                value: data.sub_portfolio_reason,
              },
            ]} />


          { /* Company KYC no need Employment Information */}
          {!isEntityKycCustomer(customerData) && (<EditableInfoCard<KYC>
            editsLocked={kycEditsLocked}
            updatedItemData={updatedKYCData}

            title="Employment Information"
            color="blue"
            itemDoc={KYCDoc}
            icon={<IconBuildingBank size={16} />}
            list={[
              {
                label: "Profession",
                editable: userClaims["cr"],
                value:
                  printArrayWithOthers("employment"),
                fieldName: "employment",
                componentType: "MultiSelect",
                dataOptions: translateArrayObj(employmentOptions),
              },
              {
                label: "Employer",
                value: data.employment_employer,
                fieldName: "employment_employer",
                componentType: "TextInput",
                editable: userClaims["cr"],
              },
              {
                label: "Job title",
                value: data.employment_jobTitle,
                fieldName: "employment_jobTitle",
                componentType: "TextInput",
                editable: userClaims["cr"],
              },
              // New-contract KYC free text; feeds the CRAM AI mapping, so edits
              // stay in the CRAM employment mapping card. Legacy KYCs lack these
              // keys and the card hides falsy non-editable rows.
              {
                label: "Occupation",
                value: data.employment_occupation,
                fieldName: "employment_occupation",
              },
              {
                label: "Industry",
                value: data.employment_industry_type,
                fieldName: "employment_industry_type",
              },
              {
                label: "Employer phone",
                value: data.employment_employerPhone,
                fieldName: "employment_employerPhone",
                componentType: "TextInput",
                editable: userClaims["cr"],


              },
              {
                label: "Years of experience",
                value: data.employment_yearsOfExperience,
                fieldName: "employment_yearsOfExperience",
                componentType: "NumberInput",
                editable: userClaims["cr"],
              },
            ]}
          />)}
          <CustomInfoCard
            title="Additional Information"
            color="violet"
            icon={<IconGitPullRequestClosed size={16} />}
            list={[
              {
                label: "Trade through other brokers",
                value: data!.tradeThroughOtherBroker,
                fieldName: "tradeThroughOtherBroker",
              },
              {
                label: "Broker name",
                value: data!.tradeThroughOtherBroker_name,
              },
              {
                label: "Trade in other markets",
                value: data!.brokerForOtherMarkets,
                fieldName: "brokerForOtherMarkets",
              },
              {
                label: "Market",
                value: data!.brokerForOtherMarkets_name,
              },
              {
                label: "Rely on financial consultations",
                value: data!.relyOnFinancialConsultations,
                fieldName: "relyOnFinancialConsultations",
              },
              {
                label: "Power of attorney",
                value: data.powerOfAttorney,
                fieldName: "powerOfAttorney",
              },
            ]}
          />

          <CustomInfoCard
            title="Declaration Information"
            color="orange"
            icon={<IconTrademark size={16} />}
            list={[
              {
                label: "Board member",
                value: data!.memberOfBoard,
              },
              ...(data!.declarationInformation || []).map((item) => ({
                label: item.position,
                value: item.entity + ", " + item.market,
              })),
            ]}
          />

          {/* New KYC Minor no need to Real beneficiaries.. We show full card of Minor Children Details*/}
          {!data?.beneficiaryInformation?.some((b) => b.beneficiary_civil_id) && (
            <CustomInfoCard
              title="Real beneficiaries"
              color="yellow"
              icon={<IconUsers size={16} />}
              list={[
                {
                  label: "Trade on behalf of others",
                  value: data!.tradeForBeneficiaries,
                  fieldName: "tradeForBeneficiaries",
                },
                ...(data!.beneficiaryInformation || []).map((item) => ({
                  label: item.relation,
                  value: item.name,
                })),
              ]}
            />
          )}

          <EditableInfoCard<KYC>
            editsLocked={kycEditsLocked}
            updatedItemData={updatedKYCData}

            itemDoc={KYCDoc}
            title=
            {<Group>
              <Text>
                Political position information
              </Text>
              {(userClaims.cr || userClaims.admin) && !kycEditsLocked && <Button variant="subtle" onClick={openPepModificationModal}>Edit</Button>}
            </Group>}
            color="teal"
            icon={<IconPodium size={16} />}
            list={[
              {
                label: "PEP",
                editable: false,
                fieldName: "politicalPosition",
                value: <Group gap={6} justify="end">
                  <Text fw={500} size="sm" ta="right">
                    {data!.politicalPosition && data!.politicalPosition.length > 0
                      ? (data!.politicalPosition || [])?.join(", ")
                      : "No"}
                  </Text>
                  {/* {(userClaims.cr || userClaims.admin) && (data!.politicalPosition && data!.politicalPosition.length > 0) && (
                    <ActionIcon
                      size="sm"
                      color="red"
                      variant="light"
                      onClick={() => clearPoliticalPositionField("politicalPosition")}
                      aria-label="Remove PEP value"
                    >
                      <IconTrash size={14} />
                    </ActionIcon>
                  )} */}
                </Group>,
              },
              {
                fieldName: "relativePoliticalPosition",
                editable: false,
                label: "Relative of PEP",
                value: <Group gap={6} justify="end">
                  <Text fw={500} size="sm" ta="right">
                    {data!.relativePoliticalPosition &&
                      data!.relativePoliticalPosition.length > 0
                      ? (data!.relativePoliticalPosition || [])?.join(", ")
                      : "No"}
                  </Text>
                  {/* {(userClaims.cr || userClaims.admin) && (data!.relativePoliticalPosition && data!.relativePoliticalPosition.length > 0) && (
                    <ActionIcon
                      size="sm"
                      color="red"
                      variant="light"
                      onClick={() => clearPoliticalPositionField("relativePoliticalPosition")}
                      aria-label="Remove relative of PEP value"
                    >
                      <IconTrash size={14} />
                    </ActionIcon>
                  )} */}
                </Group>,
              },



              ...(
                data?.relativePoliticalPositionInformation ||
                data?.relativePoliticalPosition ||
                []
              ).map((item: any) => ({
                label: item.relation,
                value: item.name,
              })),

            ]}
          />

          <CustomInfoCard
            title="Client classification"
            color="cyan"
            icon={<IconSchool size={16} />}
            list={[
              ...(data!.clientNature || ["Normal Client"]).map((item: any) => ({
                label: item,
                value: true,
              })),
            ]}
          />

          {(!!data.tin?.length || data.outsideKuwait !== undefined) && (
            <CustomInfoCard
              title="Tax Information (FATCA/CRS)"
              color="grape"
              icon={<IconReceiptTax size={16} />}
              list={[
                {
                  label: "Tax residence outside Kuwait",
                  value: data.outsideKuwait === "true" ? true : data.outsideKuwait === "false" ? false : data.outsideKuwait,
                },
                {
                  label: "Country",
                  value: data.outsideKuwait_country ? (countryMap[data.outsideKuwait_country] ?? data.outsideKuwait_country) : undefined,
                },
                {
                  label: "City",
                  value: data.outsideKuwait_city,
                },
                {
                  label: "Address",
                  value: data.outsideKuwait_address,
                },
                {
                  label: "ZIP code",
                  value: data.outsideKuwait_zip,
                  noCapitalize: true,
                },
                ...(data.tin || []).map((tinEntry) => ({
                  label: `TIN — ${countryMap[tinEntry.country] ?? tinEntry.country}`,
                  value: tinEntry.available === false
                    ? "Not available"
                    : [tinEntry.number, tinEntry.type ? `(${tinEntry.type})` : ""].filter(Boolean).join(" ") || "Available",
                  noCapitalize: true,
                })),
              ]}
            />
          )}

          {/* A minor has no risk of their own: they carry the guardian's
          rating, and there is nothing here to compute, explain or override. The
          whole card lives on the guardian's KYC instead, where the rating is
          actually produced. */}
          {!isMinorKyc && (
            <Paper shadow="xs" p="md">
              <Group justify="space-between" align="flex-start">
                <Group>
                  <ThemeIcon color="yellow" variant="light">
                    <IconSchool size={16} />
                  </ThemeIcon>
                  <Title order={5}>Risk level</Title>
                </Group>
                <Group gap="xs">
                  {canGenerateRiskRatingPdf && (
                    <Button
                      size="xs"
                      variant="light"
                      color="green"
                      leftSection={<IconFileText size={16} />}
                      loading={riskRatingPdfGenerating}
                      onClick={handleGenerateRiskRatingPdf}
                    >
                      Risk PDF
                    </Button>
                  )}
                  {canGenerateCramRiskPdf && (
                    <Button
                      size="xs"
                      variant="light"
                      color="grape"
                      leftSection={<IconFileText size={16} />}
                      loading={cramRiskPdfGenerating}
                      onClick={handleGenerateCramRiskPdf}
                    >
                      CRAM PDF
                    </Button>
                  )}
                </Group>
              </Group>
              <Space h="xs" />
              {/* CRAM live: the CRAM engine is authoritative, so the risk card
                shows the CRAM rating directly (merged card). Gated on the same
                (live && within-activation) predicate the backend uses. */}
              {kycData?.cram && isCramLiveEffective && (
                <>
                  {renderCramRatingBody({ viewOnly: false })}
                  {/* All teams (not just CRAM) see why the rating is High: the
                    override reason, the direct-high reasons, or just "CRAM"
                    when High comes from the weighted score alone. */}
                  {effectiveCramRating === "High" && (
                    <Text ta="center" tt="capitalize" c="dimmed">
                      {cramOverride
                        ? cramOverride.reason
                        : kycData.cram.directHighReasons?.length
                          ? kycData.cram.directHighReasons.join(", ")
                          : "CRAM"}
                    </Text>
                  )}
                  <Text ta="center" size="xs" c="dimmed" fs="italic" mt="xs">
                    Risk is managed by CRAM (live).
                  </Text>
                </>
              )}
              {!(kycData?.cram && isCramLiveEffective) && (
                <>
                  <Center>
                    <Stack ta="center" gap="xs">
                      <Title>
                        <Text
                          tt="capitalize"
                          c={
                            privateData?.state?.risk_code === "high" ? "red" : "green"
                          }
                        >
                          {privateData?.state?.risk_code}
                        </Text>
                      </Title>
                      <Text tt="capitalize" c="dimmed">
                        {privateData?.state?.risk}
                      </Text>
                      {/* CRAM Task 8 — legacy manual risk overrides are hidden for
                    CRAM-bound KYCs; the rating is managed by the CRAM engine. */}
                      {kycData?.cram && isCramShadow && (
                        <Text size="xs" c="dimmed" fs="italic" ta="center">
                          Legacy risk applies. CRAM runs in shadow mode (view only) and does not change this risk.
                        </Text>
                      )}
                      {kycData?.cram && !isCramShadow && !isCramLiveEffective && (
                        <Text size="xs" c="dimmed" fs="italic" ta="center">
                          CRAM is not active for this KYC; legacy risk applies.
                        </Text>
                      )}
                      {/* Legacy manual risk overrides stay available whenever CRAM
                    is not the authoritative engine for this KYC (shadow / off /
                    before activation). They are only hidden when CRAM is live
                    and in effect, where the engine manages the rating. Wrapped in
                    a centered Group so the buttons size to their text instead of
                    stretching to the full card width. */}
                      {!(kycData?.cram && isCramLiveEffective) && (
                        <Group justify="center" gap="xs" wrap="wrap">
                          {privateData?.state?.risk_code === "high" && !customerData?.highRiskOverride && (
                            <Button
                              color="red"
                              onClick={() => {
                                setConfirmDialog({
                                  title: "Confirm",
                                  action: "Override low risk",
                                  description: `Change ${data?.name_en} to low risk?`,
                                  buttonColor: "red",
                                  textFieldDescription: "Reason",
                                  textField: "reason",
                                  callback: async (values: any) => {
                                    await riskOverride({
                                      customerID: customerData.id,
                                      action: "add",
                                      reason: values.reason,
                                      targetRisk: "low",
                                    });
                                  },
                                });
                              }}
                            >
                              Risk override
                            </Button>
                          )}
                          {privateData?.state?.risk_code === "high" && !KYCDoc?.data().highriskOverrideReason && (
                            <Button
                              color="red"
                              onClick={() => {
                                setConfirmDialog({
                                  title: "Confirm",
                                  action: "Override high risk reason ",
                                  description: `Change ${data?.name_en}  risk reason ?`,
                                  buttonColor: "red",
                                  textFieldDescription: "Reason",
                                  textField: "reason",
                                  callback: async (values: any) => {
                                    await riskOverrideKYC({
                                      customerID: customerData.id!,
                                      kycID: KYCDoc?.id!,
                                      action: "update",
                                      reason: values.reason,
                                      targetRisk: "high",
                                    });
                                  },
                                });
                              }}
                            >
                              Risk Reason override
                            </Button>
                          )}
                          {privateData?.state?.risk_code === "high" && KYCDoc?.data().highriskOverrideReason && (
                            <Button
                              color="red"
                              onClick={() => {
                                setConfirmDialog({
                                  title: "Confirm",
                                  action: "Override high risk reason ",
                                  description: `Change ${data?.name_en}  risk reason ?`,
                                  buttonColor: "red",
                                  textFieldDescription: "Reason",
                                  textField: "reason",
                                  callback: async (values: any) => {
                                    await riskOverrideKYC({
                                      customerID: customerData.id!,
                                      kycID: KYCDoc?.id,
                                      action: "remove",
                                      reason: values.reason,
                                      targetRisk: "high",
                                    });
                                  },
                                });
                              }}
                            >
                              Remove Risk Reason override
                            </Button>
                          )}
                          {customerData?.lowRiskOverride && (
                            <Button
                              color="red"
                              onClick={() => {
                                setConfirmDialog({
                                  title: "Confirm",
                                  action: "Remove override",
                                  description: `Remove ${data?.name_en}'s low risk override?'`,
                                  buttonColor: "red",
                                  callback: async () => {
                                    await riskOverride({
                                      customerID: customerData.id,
                                      action: "remove",
                                      targetRisk: "low",
                                    });
                                  },
                                });
                              }}
                            >
                              Remove override
                            </Button>
                          )}
                          {privateData?.state?.risk_code === "low" && !customerData?.lowRiskOverride && (
                            <Button
                              color="red"
                              onClick={() => {
                                setConfirmDialog({
                                  title: "Confirm",
                                  action: "Override high risk",
                                  description: `Change ${data?.name_en} to high risk?`,
                                  buttonColor: "red",
                                  textFieldDescription: "Reason",
                                  textField: "reason",
                                  callback: async (values: any) => {
                                    await riskOverride({
                                      customerID: customerData?.id,
                                      action: "add",
                                      reason: values.reason,
                                      targetRisk: "high",
                                    });
                                  },
                                });
                              }}
                            >
                              Risk override
                            </Button>
                          )}
                          {customerData?.highRiskOverride && (
                            <Button
                              color="red"
                              onClick={() => {
                                setConfirmDialog({
                                  title: "Confirm",
                                  action: "Remove override",
                                  description: `Remove ${data?.name_en}'s high risk override?'`,
                                  buttonColor: "red",
                                  callback: async () => {
                                    await riskOverride({
                                      customerID: customerData?.id,
                                      action: "remove",
                                      targetRisk: "high",
                                    });
                                  },
                                });
                              }}
                            >
                              Remove override
                            </Button>
                          )}
                        </Group>
                      )}
                    </Stack>
                  </Center>
                  {/* CRAM rating merged into the same card. In shadow / off the CRAM
                rating is informational only (the legacy risk above is the one
                actually used); we still surface the full CRAM result so no
                information is lost. */}
                  {kycData?.cram && (
                    <>
                      <Divider
                        my="md"
                        label="CRAM rating (informational)"
                        labelPosition="center"
                      />
                      <Center mb="xs">
                        {isCramShadow ? (
                          <Badge variant="light" color="gray">
                            Shadow — computed for comparison, does not affect risk
                          </Badge>
                        ) : (
                          <Badge variant="light" color="gray">
                            Not active — legacy risk applies
                          </Badge>
                        )}
                      </Center>
                      {renderCramRatingBody({ viewOnly: false })}
                    </>
                  )}
                </>
              )}
            </Paper>
          )}

          {aiPrecheck && (userClaims.cr || userClaims.admin) && (
            <AiPrecheckCard precheck={aiPrecheck} kycData={kycData} />
          )}

          {/* CRAM Task 8 — AI industry/occupation mapping review + override.
              Styled like the Client Information cards; the CR must confirm or
              change each mapping. When unresolved the whole card is flagged. */}
          {showCramMappingCard && (
            <Paper
              shadow="xs"
              p="md"
              style={cramMappingNeedsAttention ? { backgroundColor: 'rgba(255, 193, 7, 0.1)' } : undefined}
            >
              <Group justify="space-between">
                <Group>
                  <ThemeIcon color="grape" variant="light">
                    <IconSchool size={16} />
                  </ThemeIcon>
                  <Title order={5}>CRAM employment mapping</Title>
                  {cramMappingNeedsAttention && (
                    <Tooltip
                      multiline
                      w={260}
                      withArrow
                      label="Confirm to accept the AI suggestion, or Update to pick a different value. Either choice records a CR decision and recomputes the CRAM rating immediately."
                    >
                      <ThemeIcon variant="transparent" color="orange" size={24}>
                        <IconAlertCircle size={24} />
                      </ThemeIcon>
                    </Tooltip>
                  )}
                </Group>
                {/* Header reflects the CR RESOLUTION state, not the raw AI run
                    status. The AI status can stay "partial" (e.g. a budget-
                    skipped target) forever; once CR has confirmed every row the
                    card is effectively resolved, so showing "partial" then is
                    misleading. */}
                <Group gap="xs" wrap="nowrap">
                  <Badge
                    variant="light"
                    color={!kycData?.aiMapping ? "gray" : cramMappingNeedsAttention ? "yellow" : "green"}
                    leftSection={
                      cramMappingNeedsAttention || !kycData?.aiMapping ? (
                        <IconAlertCircle size={12} />
                      ) : (
                        <IconCheck size={12} />
                      )
                    }
                  >
                    {!kycData?.aiMapping
                      ? "Not mapped"
                      : cramMappingNeedsAttention
                        ? "Needs review"
                        : "Confirmed"}
                  </Badge>
                  {canCallCramAiMapping && KYCDoc && (
                    <Tooltip label="Run the AI mapping again">
                      <ActionIcon
                        variant="light"
                        color="grape"
                        loading={aiMappingCallBusy}
                        onClick={async () => {
                          setAiMappingCallBusy(true);
                          try {
                            await cramRequestAiMapping({
                              customerID: customerData.id!,
                              kycID: KYCDoc.id,
                            });
                            showNotification({
                              color: "green",
                              title: "AI mapping requested",
                              message: "The mapping will appear here once it completes.",
                            });
                          } catch (e: any) {
                            showNotification({
                              color: "red",
                              title: "Could not run the AI mapping",
                              message: e.message,
                            });
                          }
                          setAiMappingCallBusy(false);
                        }}
                      >
                        <IconRefresh size={16} />
                      </ActionIcon>
                    </Tooltip>
                  )}
                </Group>
              </Group>

              {!kycData?.aiMapping && (
                <>
                  <Space h="xs" />
                  <Alert color="gray" variant="light" icon={<IconAlertCircle size={16} />}>
                    No AI mapping exists for this KYC, so occupation and industry contribute
                    nothing to the CRAM rating.
                  </Alert>
                </>
              )}

              <Space h="xs" />
              <Stack gap="sm">
                {cramMappingRows.map((row) => {
                  const label = row.target === "occupation" ? "Occupation" : "Industry";
                  const sug = row.suggestion;
                  const sel = row.selected;
                  const effectiveLabel =
                    row.effectiveKey
                      ? (row.options.find((o) => o.value === row.effectiveKey)?.label || row.effectiveKey)
                      : null;
                  return (
                    <Paper
                      key={row.target}
                      withBorder
                      p="sm"
                      radius="md"
                      pos="relative"
                      style={row.needsAttention ? { borderColor: "var(--mantine-color-red-4)" } : undefined}
                    >
                      <LoadingOverlay visible={cramMappingSaving === row.target} zIndex={5} overlayProps={{ blur: 1 }} />
                      <Group justify="space-between" align="center" wrap="nowrap" mb={6}>
                        <Group gap="xs" wrap="nowrap">
                          <Text fw={600}>{label}</Text>
                          {row.resolved ? (
                            <Badge size="sm" color="green" variant="light" leftSection={<IconCheck size={12} />}>
                              Confirmed
                            </Badge>
                          ) : row.needsAttention ? (
                            <Badge size="sm" color="red" variant="light" leftSection={<IconAlertCircle size={12} />}>
                              Needs review
                            </Badge>
                          ) : null}
                        </Group>
                        <Group gap={6} wrap="nowrap" style={{ flexShrink: 0 }}>
                          {/* Once a row is resolved the confirm button is removed
                              — it would never be used again and the "Confirmed"
                              badge already shows the saved state. */}
                          {!row.resolved && (
                            <Tooltip
                              label={
                                sug?.suggestedKey
                                  ? "Confirm AI suggestion"
                                  : "No AI suggestion — use Update to pick an option"
                              }
                            >
                              {/* Confirming is only allowed when there is a real
                                  key to accept. An empty/"no mapping" confirm is
                                  blocked so CR must actively pick an option. */}
                              <ActionIcon
                                variant="filled"
                                color="green"
                                loading={cramMappingSaving === row.target}
                                disabled={cramMappingSaving !== null || !sug?.suggestedKey}
                                onClick={() => applyCramMapping(row.target, sug?.suggestedKey ?? null)}
                              >
                                <IconCheck size={16} />
                              </ActionIcon>
                            </Tooltip>
                          )}
                          <Tooltip label="Update mapping">
                            <ActionIcon
                              variant="default"
                              disabled={cramMappingSaving !== null || row.options.length === 0}
                              onClick={() => {
                                setCramChangeValue(row.effectiveKey);
                                setCramChangeModal({
                                  target: row.target,
                                  label,
                                  currentKey: row.effectiveKey,
                                  options: row.options,
                                });
                              }}
                            >
                              <IconEdit size={16} />
                            </ActionIcon>
                          </Tooltip>
                        </Group>
                      </Group>

                      <Stack gap={6} style={{ minWidth: 0 }}>
                        <Group gap={4} wrap="nowrap">
                          <Text size="xs" c="dimmed" w={140} style={{ flexShrink: 0 }}>Customer typed value</Text>
                          <Text size="sm">{row.typed || "—"}</Text>
                        </Group>

                        {/* Only the effective mapping is shown. When the CR
                            overrode the AI suggestion, an orange info icon (like
                            the Income Information change indicator) reveals what
                            changed, by whom, and the original AI suggestion. */}
                        <Group gap={4} wrap="nowrap" align="center">
                          <Text size="xs" c="dimmed" w={140} style={{ flexShrink: 0 }}>Mapping</Text>
                          <Group gap={6} wrap="nowrap" align="center">
                            <Text size="sm">
                              {effectiveLabel || <Text span c="dimmed">no mapping</Text>}
                            </Text>
                            {sel ? (
                              <Tooltip
                                bg="white"
                                withArrow
                                label={
                                  <Card withBorder>
                                    <Text c="black">
                                      AI suggestion :{" "}
                                      <Text span c="blue" inherit>
                                        {sug?.suggestedLabel || sug?.suggestedKey || "none"}
                                        {sug?.suggestedKey
                                          ? sug.source === "exact"
                                            ? " (exact)"
                                            : ` (${Math.round((sug.confidence || 0) * 100)}%)`
                                          : ""}
                                      </Text>
                                    </Text>
                                    <Text c="black">
                                      CR mapping :{" "}
                                      <Text span c="blue" inherit>
                                        {sel.label || sel.key || "no mapping"}
                                      </Text>
                                    </Text>
                                    <Text c="black">
                                      Changed by :{" "}
                                      <Text span c="blue" inherit>
                                        {sel.byEmail || sel.byUid || "—"}
                                      </Text>
                                    </Text>
                                    <Text c="black">
                                      Changed on :{" "}
                                      <Text span c="blue" inherit>
                                        {sel.at?.toDate
                                          ? sel.at.toDate().toLocaleString("en-gb")
                                          : "—"}
                                      </Text>
                                    </Text>
                                  </Card>
                                }
                              >
                                <ThemeIcon variant="transparent" color="orange" size="sm">
                                  <IconAlertCircle size={15} />
                                </ThemeIcon>
                              </Tooltip>
                            ) : (
                              <Text span size="xs" c="dimmed">
                                {sug?.suggestedKey
                                  ? sug.source === "exact"
                                    ? "(AI · exact)"
                                    : `(AI · ${Math.round((sug.confidence || 0) * 100)}%)`
                                  : sug?.budgetSkipped
                                    ? "(skipped)"
                                    // Say so rather than rendering nothing: a
                                    // blank here is indistinguishable from a
                                    // rendering bug.
                                    : sug
                                      ? "(AI found no match)"
                                      : "(AI has not run)"}
                              </Text>
                            )}
                          </Group>
                        </Group>
                      </Stack>
                    </Paper>
                  );
                })}
              </Stack>
            </Paper>
          )}

          {/* CRAM AML breakdown modal. */}
          <Modal
            opened={cramBreakdownOpen}
            onClose={() => setCramBreakdownOpen(false)}
            title="CRAM AML breakdown"
            size="xl"
            centered
          >
            {kycData?.cram?.breakdown ? (
              <Stack gap="md">
                <Group justify="space-between" align="flex-start">
                  <Group gap="xs">
                    <Badge size="lg" color={cramRatingColor(kycData.cram.rating)}>{kycData.cram.rating}</Badge>
                    <Text c="dimmed">Score: {kycData.cram.score}</Text>
                  </Group>
                  <Text size="sm" c="dimmed">
                    Pre-rule rating: {kycData.cram.breakdown.preRuleRating}
                  </Text>
                </Group>

                {(() => {
                  const rows = kycData ? getCramBreakdownRows(kycData) : [];
                  const flagged = rows.filter((r) => r.status === "missing" || r.status === "unscored");
                  return (
                    <div>
                      <Table withTableBorder withColumnBorders fz="xs">
                        <Table.Thead>
                          <Table.Tr>
                            <Table.Th>Category</Table.Th>
                            <Table.Th>Input</Table.Th>
                            <Table.Th>Score</Table.Th>
                            <Table.Th>Weighted</Table.Th>
                            <Table.Th>Status</Table.Th>
                          </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                          {rows.map((r) => {
                            const isDirectHigh = r.category === "directHigh";
                            let icon = <IconCheck size={14} color="var(--mantine-color-green-6)" />;
                            let statusText = "Used";
                            let statusColor: string | undefined = undefined;
                            let rowBg: string | undefined = undefined;
                            if (isDirectHigh && r.status === "used") {
                              // A direct-high factor fired → floors the rating at High.
                              icon = <IconAlertCircle size={14} color="var(--mantine-color-red-6)" />;
                              statusText = "Flags High";
                              statusColor = "red";
                              rowBg = "var(--mantine-color-red-0)";
                            } else if (isDirectHigh) {
                              // No direct-high factor → no effect on the rating.
                              icon = <IconMinus size={14} color="var(--mantine-color-gray-5)" />;
                              statusText = "No effect";
                              statusColor = "dimmed";
                            } else if (r.status === "missing") {
                              icon = <IconAlertCircle size={14} color="var(--mantine-color-red-6)" />;
                              statusText = "Missing";
                              statusColor = "red";
                              rowBg = "var(--mantine-color-red-0)";
                            } else if (r.status === "unscored") {
                              icon = <IconAlertCircle size={14} color="var(--mantine-color-yellow-7)" />;
                              statusText = "Not scored — check mapping";
                              statusColor = "yellow";
                              rowBg = "var(--mantine-color-yellow-0)";
                            } else if (r.status === "none") {
                              icon = <IconX size={14} color="var(--mantine-color-gray-5)" />;
                              statusText = "Not provided";
                              statusColor = "dimmed";
                            }
                            return (
                              <Table.Tr key={r.category} style={rowBg ? { backgroundColor: rowBg } : undefined}>
                                <Table.Td>
                                  {r.label}
                                  {r.mandatory && <Text span c="red"> *</Text>}
                                </Table.Td>
                                <Table.Td>
                                  {r.candidates.length > 0 ? (
                                    <Stack gap={2}>
                                      {r.candidates.map((cand, ci) => (
                                        <Group key={`${r.category}-${cand.key}-${ci}`} gap={6} wrap="nowrap">
                                          <Text size="xs" fw={cand.chosen ? 700 : 400} c={cand.chosen ? undefined : "dimmed"}>
                                            {cand.key}
                                          </Text>
                                          <Text size="xs" c="dimmed">({cand.score})</Text>
                                          {cand.origin && (
                                            <Badge
                                              size="xs"
                                              variant="light"
                                              color={cand.origin === "requested" ? "blue" : "gray"}
                                            >
                                              {cand.origin === "requested" ? "requested" : "existing"}
                                            </Badge>
                                          )}
                                          {cand.chosen && r.candidates.length > 1 && (
                                            <Badge size="xs" variant="light" color="blue">max</Badge>
                                          )}
                                        </Group>
                                      ))}
                                    </Stack>
                                  ) : r.input ? (
                                    <Text size="xs">{r.input}</Text>
                                  ) : (
                                    <Text span c="dimmed">—</Text>
                                  )}
                                </Table.Td>
                                <Table.Td>{r.score}</Table.Td>
                                <Table.Td>{r.weighted}</Table.Td>
                                <Table.Td>
                                  <Group gap={6} wrap="nowrap">
                                    {icon}
                                    <Text size="xs" c={statusColor}>{statusText}</Text>
                                  </Group>
                                </Table.Td>
                              </Table.Tr>
                            );
                          })}
                          <Table.Tr>
                            <Table.Td fw={600}>Score (weighted sum)</Table.Td>
                            <Table.Td c="dimmed">Sum of the weighted column</Table.Td>
                            <Table.Td></Table.Td>
                            <Table.Td fw={600}>{kycData.cram.breakdown.weightedSum}</Table.Td>
                            <Table.Td>
                              {/* Show the final rating so the badge name and
                                  color always agree (e.g. a FATF / direct-high
                                  floor reads High + red even when the score
                                  alone is Medium). The score's own pre-rule
                                  rating is still shown as context in the header. */}
                              <Badge size="sm" color={cramRatingColor(kycData.cram.rating)}>
                                {kycData.cram.rating}
                              </Badge>
                            </Table.Td>
                          </Table.Tr>
                        </Table.Tbody>
                      </Table>
                      {flagged.length > 0 && (
                        <Alert mt="xs" color="yellow" variant="light" icon={<IconAlertCircle size={16} />} title="Something is not correct">
                          {flagged.map((r) => r.label).join(", ")} {flagged.length === 1 ? "was" : "were"} not scored (missing input or an unmatched value). Re-submit or fix the mapping to recompute the rating.
                        </Alert>
                      )}
                    </div>
                  );
                })()}

                {kycData.cram.fatfHits?.length > 0 && (
                  <div>
                    <Text fw={600} size="sm" mb={4}>FATF hits</Text>
                    <Stack gap={2}>
                      {kycData.cram.fatfHits.map((h, i) => (
                        <Text key={`fatf-${i}`} size="sm" c="orange">• {h}</Text>
                      ))}
                    </Stack>
                  </div>
                )}

                {kycData.cram.directHighReasons?.length > 0 && (
                  <div>
                    <Text fw={600} size="sm" mb={4}>Direct high-risk reasons</Text>
                    <Stack gap={2}>
                      {kycData.cram.directHighReasons.map((r, i) => (
                        <Text key={`mdh-${i}`} size="sm" c="red">• {r}</Text>
                      ))}
                    </Stack>
                  </div>
                )}

                {kycData.cram.prohibitedReasons?.length > 0 && (
                  <div>
                    <Text fw={600} size="sm" mb={4}>Prohibited reasons</Text>
                    <Stack gap={2}>
                      {kycData.cram.prohibitedReasons.map((r, i) => (
                        <Text key={`mpr-${i}`} size="sm" c="red" fw={600}>• {r}</Text>
                      ))}
                    </Stack>
                  </div>
                )}
              </Stack>
            ) : (
              <Text c="dimmed">No breakdown available.</Text>
            )}
          </Modal>

          {/* CRAM mapping "Change" modal. */}
          <Modal
            opened={!!cramChangeModal}
            onClose={() => setCramChangeModal(null)}
            title={`Change ${cramChangeModal?.label ?? ""} mapping`}
            centered
          >
            {cramChangeModal && (
              <Stack>
                <Text size="sm" c="dimmed">
                  Select the CRAM {cramChangeModal.target} value to apply. A
                  value is required — "no mapping" is not allowed.
                </Text>
                <Select
                  placeholder="Search…"
                  searchable
                  data={cramChangeModal.options}
                  value={cramChangeValue}
                  onChange={setCramChangeValue}
                  nothingFoundMessage="No match"
                  maxDropdownHeight={260}
                />
                <Group justify="flex-end">
                  <Button variant="default" onClick={() => setCramChangeModal(null)}>Cancel</Button>
                  <Button
                    loading={cramMappingSaving === cramChangeModal.target}
                    disabled={!cramChangeValue}
                    onClick={async () => {
                      const target = cramChangeModal.target;
                      if (!cramChangeValue) return;
                      const ok = await applyCramMapping(target, cramChangeValue);
                      // Keep the modal open on failure so the user's selection
                      // isn't silently discarded; the error is shown via setMsg.
                      if (ok) setCramChangeModal(null);
                    }}
                  >
                    Save
                  </Button>
                </Group>
              </Stack>
            )}
          </Modal>
          { /* Company KYC no need signature here */}
          {!isEntityKycCustomer(customerData) && data!.signature && (
            <ImageViewCard photo={data.signature} title="Signature" />
          )}
          {amlScreeningPanel}

          {kycData && (!!kycData?.beneficiaryInformation?.length) && (
            <MinorInfoCard
              kyc={kycData}
              itemDoc={KYCDoc}
              cols={1}
              title={"Minor Children Details"}
              updatedItemData={updatedKYCData}
            />
          )}
          <CustomInfoCard
            title="KYC Details"
            color="gray"
            icon={<IconInfoCircle size={16} />}
            list={[
              {
                label: "Created",
                value: data.created ? formatDateValue(data.created) : undefined,
              },
              {
                label: "Product",
                value: data.completedKYCData?.productTitle,
              },
              {
                label: "Contract type",
                value: data.contractType ?? data.completedKYCData?.contractType,
              },
              {
                label: "Form version",
                value: data.completedKYCData?.version,
                noCapitalize: true,
              },
              {
                label: "Manual (staff-filled)",
                value: data.manual ?? data.completedKYCData?.manual,
              },
              {
                label: "Assisted by",
                value: formatAssistedBy(data.assisted_by),
                noCapitalize: true,
              },
              {
                label: "Consent granted",
                value: data.consent_granted,
              },
              {
                label: "Selling agent review required",
                value: data.require_selling_agent_review,
              },
              {
                label: "Submitted from IP",
                value: data.ip,
                noCapitalize: true,
              },
              {
                label: "PDF tags",
                value: data.pdfTags?.length ? data.pdfTags.join(", ") : undefined,
                noCapitalize: true,
              },
              {
                label: "Tradex sync",
                value: data.tradexSyncStatus ? (
                  <Text
                    fw={500}
                    size="sm"
                    ta="right"
                    tt="capitalize"
                    c={data.tradexSyncStatus.status === "success" ? "green" : data.tradexSyncStatus.status === "error" ? "red" : "yellow"}
                  >
                    {data.tradexSyncStatus.status}{data.tradexSyncStatus.message ? ` — ${data.tradexSyncStatus.message}` : ""}
                  </Text>
                ) : undefined,
              },
              {
                label: "High-risk override reason",
                value: data.highriskOverrideReason,
              },
              {
                label: "Rejection comments",
                value: data.completedKYCData?.rejectKycComments,
              },
            ]}
          />

          {data.guardianPaciData && <Paper>
            <Space h="xs" />
            <Space h="xs" />
            <CustomInfoCard
              title="Beneficiary Information"
              color="yellow"
              icon={<IconTrademark size={16} />}
              list={[
                {
                  label: "Name (Ar)",
                  value: data?.guardianPaciData?.PersonalData?.FullNameAr,
                },
                {
                  label: "Name (En)",
                  value: data?.guardianPaciData?.PersonalData?.FullNameEn,
                },
                {
                  label: "Civil ID",
                  value: data?.guardianPaciData?.PersonalData?.CivilID,
                  noCapitalize: true,
                },
                {
                  label: "Mobile",
                  value: data?.guardianPaciData?.PersonalData?.MobileNumber,
                  noCapitalize: true,
                },
                {
                  label: "Email",
                  value: data?.guardianPaciData?.PersonalData?.EmailAddress,
                  noCapitalize: true,
                },
              ]}
            />
          </Paper>}

          {isEntityKycCustomer(customerData) && !data?.interviewFormData &&
            <Paper shadow="xs" p="md">
              <Group justify="space-between" wrap="nowrap" style={{ width: '100%' }}>
                <ThemeIcon color="green" variant="light">
                  <IconListDetails size={16} />
                </ThemeIcon>
                <Title order={5} style={{ textAlign: 'left', width: '100%' }}>Interview Form Data</Title>
              </Group>
              <Space h="xs" />
              <Center>
                <Stack ta="center" gap="xs">
                  <Text tt="capitalize" c="dimmed">
                    No interview form data found for this entity.
                  </Text>

                  <Button
                    color="red"
                    onClick={() => openInterviewModal()}
                  >
                    Add interview form data
                  </Button>
                </Stack>
              </Center>
              <Space h="xs" />
            </Paper>
          }

          {data?.interviewFormData && (
            <Stack ta="center" gap="xs">
              <CustomInfoCard
                title="Interview Form Data"
                color="green"
                icon={<IconListDetails size={16} />}
                list={[
                  {
                    label: "Interview Type",
                    value: data?.interviewFormData?.interviewType,
                  },
                  {
                    label: "Interview Address",
                    value: data?.interviewFormData?.interviewAddress,
                  },
                  {
                    label: "General Remarks",
                    value: data?.interviewFormData?.generalRemarks,
                  },
                  {
                    label: "Entity Requirements",
                    value: data?.interviewFormData?.entityRequirements,
                  },
                  {
                    label: "Interviewee",
                    value: (() => {
                      const signatory = enrichedSignatories.find(
                        (s) => s.id === data?.interviewFormData?.intervieweeID
                      );

                      if (!signatory) {
                        return data?.interviewFormData?.intervieweeID || "-";
                      }

                      return (
                        <>

                          <Link
                            to={`/customers/${signatory.id}/`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Text span c="blue" tt="capitalize" size="sm">
                              {signatory.customer?.name_en || signatory.customer?.name_ar || signatory.id}
                            </Text>
                          </Link>
                        </>
                      );
                    })(),
                  },
                  {
                    label: "Interview Date",
                    value: formatDateValue(data?.interviewFormData?.interviewDate),
                  },
                ]}
              />
            </Stack>
          )}

          {isEntityKycCustomer(customerData) && (
            <KycListTableViewer
              cardTitle="Controlling Persons"
              cardIcon={<IconUserShield size={16} />}
              accentColor={privateData?.state?.risk_code === "high" ? "red" : "green"}
              sections={[
                {
                  title: 'Board Of Directors',
                  icon: <IconUsers size={13} />,
                  data: kycData?.board_of_directors,
                  columns: [
                    { label: 'Name', key: 'full_name' },
                    { label: 'Arabic Name', key: 'name_ar' },
                    { label: 'Civil ID', key: 'civilID' },
                    { label: 'Customer', key: 'customerID', render: (value) => value ? <Link to={`/customers/${value}/`} target="_blank" rel="noopener noreferrer">{String(value)}</Link> : 'Not linked' },
                    { label: 'Date of Birth', key: 'date_of_birth' },
                    { label: 'Nationality', key: 'nationality', render: (value) => countryMap[value as string] ?? value, },
                    { label: 'Role', key: 'role' },
                  ],
                },
                {
                  title: 'Executive Management',
                  icon: <IconUserCheck size={13} />,
                  data: kycData?.executive_management,
                  columns: [
                    { label: 'Name', key: 'full_name' },
                    { label: 'Arabic Name', key: 'name_ar' },
                    { label: 'Civil ID', key: 'civilID' },
                    { label: 'Customer', key: 'customerID', render: (value) => value ? <Link to={`/customers/${value}/`} target="_blank" rel="noopener noreferrer">{String(value)}</Link> : 'Not linked' },
                    { label: 'Date of Birth', key: 'date_of_birth' },
                    { label: 'Nationality', key: 'nationality', render: (value) => countryMap[value as string] ?? value, },
                    { label: 'Role', key: 'role' },
                  ],
                },
                {
                  title: 'Authorized Signatories',
                  icon: <IconUserCheck size={13} />,
                  data: enrichedSignatories.map((signatory) => ({
                    id: signatory.customer?.id,
                    name: signatory.customer?.name_en,
                    civilID: signatory.customer?.civilID,
                    crmID: signatory.customer?.crmID,
                    role: signatory.role_within_company,
                  })),
                  columns: [
                    { label: 'ID', key: 'id' },
                    { label: 'Name', key: 'name' },
                    { label: 'CRM ID', key: 'crmID' },
                    { label: 'Civil ID', key: 'civilID' },
                    { label: 'Role', key: 'role' },
                  ],
                },
                {
                  title: 'Board Membership & Insider Information',
                  icon: <IconUserCheck size={13} />,
                  data: kycData?.authorized_signatories_board_membership,
                  columns: [
                    { label: 'Entity Name', key: 'entity_name' },
                    { label: 'Exchange Market', key: 'exchange_market' },
                    { label: 'Name', key: 'name' },
                    { label: 'Role', key: 'role' },
                  ],
                },
              ]}
            >
              {[
                ...(kycData?.board_of_directors ?? []).map(person => ({ id: person.customerID, name: person.full_name, role: 'Board director', controllingPerson: person })),
                ...(kycData?.executive_management ?? []).map(person => ({ id: person.customerID, name: person.full_name, role: 'Executive manager', controllingPerson: person })),
                ...enrichedSignatories.map(person => ({ id: person.id, name: person.customer?.name_en || person.id, role: 'Authorized signatory', controllingPerson: undefined })),
              ].map((person, index) => (
                <ControllingPersonScreening key={`${person.role}-${person.id ?? index}`}
                  kycData={kycData} customerID={customerData.id!} relatedCustomerID={person.id} controllingPerson={person.controllingPerson}
                  originalSubmittedAt={originalSubmittedAt} originalSubmissionLoading={originalSubmissionLoading} originalSubmissionError={originalSubmissionError}
                  name={`${person.name} (${person.role})`} />
              ))}
            </KycListTableViewer>
          )}
          {isEntityKycCustomer(customerData) && (
            <KycListTableViewer
              cardTitle="Ultimate Beneficial Owners"
              cardIcon={<IconCrown size={16} />}
              accentColor={privateData?.state?.risk_code === "high" ? "red" : "green"}
              sections={[
                {
                  title: 'Beneficiaries',
                  icon: <IconCrown size={13} />,
                  data: kycData?.beneficiaries as Record<string, unknown>[] | [],
                  columns: [
                    { label: 'Civil ID', key: 'civil_id' },
                    { label: 'Name', key: 'name' },
                    { label: 'Customer', key: 'customerID', render: (value) => value ? <Link to={`/customers/${value}/`} target="_blank" rel="noopener noreferrer">{String(value)}</Link> : 'Not linked' },
                    { label: 'Nationality', key: 'nationality', render: (value) => countryMap[value as string] ?? value, },
                    { label: 'Ownership %', key: 'ownership_percentage' },
                    { label: 'Status', key: 'direct_indirect' },
                  ],
                },
              ]}
            >
              {(kycData?.beneficiaries ?? []).map((owner, index) => (
                <BeneficialOwnerScreening key={`owner-${index}`} kycData={kycData} customerID={customerData.id!} owner={owner} />
              ))}
            </KycListTableViewer>
          )}
          {isEntityKycCustomer(customerData) && (
            <KycListTableViewer
              cardTitle="Account Beneficiary"
              cardIcon={<IconCoins size={16} />}
              accentColor={privateData?.state?.risk_code === "high" ? "red" : "green"}
              sections={[
                {
                  title: 'Account Beneficiary',
                  icon: <IconCoins size={13} />,
                  data: kycData?.account_beneficiary,
                  columns: [
                    { label: 'Name', key: 'name' },
                    { label: 'Relation', key: 'relation' },
                  ],
                },
              ]}
            />
          )}
          {isEntityKycCustomer(customerData) && (
            <KycListTableViewer
              cardTitle="Connected Parties"
              cardIcon={<IconUserShield size={16} />}
              accentColor={privateData?.state?.risk_code === "high" ? "red" : "green"}
              sections={[
                {
                  title: 'Connected Parties',
                  icon: <IconUserShield size={13} />,
                  data: kycData?.entity_subsidiaries,
                  columns: [
                    { label: 'Name', key: 'ownership_name' },
                    { label: 'Percentage %', key: 'ownership_percentage' },
                    { label: 'Type', key: 'ownership_type' },
                  ],
                },
              ]}
            />
          )}
        </SimpleGrid >
      )}


      { /* This Section is for Commercial Register */}
      {kycData && kycData.paciData && isEntityKycCustomer(customerData) && (
        <>
          <Space h="xl" />
          <Paper
            withBorder
          >
            {/* Header */}
            <Group
              justify="space-between"
              align="center"
              p="sm"
              style={{ cursor: 'pointer' }}
              onClick={toggle}
            >
              <Group gap="sm">
                <ThemeIcon variant="gradient" gradient={{ from: 'pink', to: 'grape' }} radius="md">
                  <IconFileText size={16} />
                </ThemeIcon>
                <Text fw={600} c="pink">
                  Authorized Signatories Information
                </Text>
              </Group>
              <IconChevronUp
                size={16}
                style={{
                  color: 'var(--mantine-color-gray-5)',
                  transform: opened ? 'rotate(0deg)' : 'rotate(180deg)',
                  transition: 'transform 200ms ease',
                }}
              />
            </Group>

            {/* Content */}
            <Collapse expanded={opened}>
              <Divider />
              <Box p="md">
                <SimpleGrid cols={3}>
                  <EditableInfoCard<KYC>
                    editsLocked={kycEditsLocked}
                    updatedItemData={updatedKYCData}
                    title="Authorized Person Information"
                    color="blue"
                    icon={<IconPhone size={16} />}
                    itemDoc={KYCDoc}
                    list={[
                      {
                        label: "Name (en)",
                        value: kycData.paciData.PersonalData?.FullNameEn,
                      },

                      {
                        label: "Name (ar)",
                        value: kycData.paciData.PersonalData?.FullNameAr,
                      },
                      {
                        label: "Civil ID",
                        value: kycData.paciData.PersonalData?.CivilID,
                      },
                      {
                        label: "Birth Date",
                        value: kycData.paciData.PersonalData?.BirthDate
                          ? new Date(kycData.paciData.PersonalData.BirthDate).toLocaleDateString("en-gb")
                          : undefined,
                        fieldName: "birthDate",
                      },
                      {
                        label: "Mobile",
                        value: kycData.paciData.PersonalData?.MobileNumber,
                      },
                      {
                        label: "Nationality",
                        value: kycData.paciData.PersonalData?.NationalityAr,
                      },
                      {
                        label: "Gender",
                        value: kycData.paciData.PersonalData?.Gender || undefined,
                      },
                      {
                        label: "PACI Nationality (ar)",
                        value: kycData.paciData.PersonalData?.NationalityAr || undefined,
                      },
                      {
                        label: "PACI Nationality (en)",
                        value: kycData.paciData.PersonalData?.NationalityEn || undefined,
                      },
                      {
                        label: "PACI Sponsor",
                        value: kycData.paciData.PersonalData?.GovData?.SponsorName || undefined
                      },
                      {
                        label: "PACI Mobile",
                        value: kycData.paciData.PersonalData?.MobileNumber || undefined
                      },
                      {
                        label: "PACI Email",
                        value: kycData.paciData.PersonalData?.EmailAddress || undefined,
                        noCapitalize: true,
                      },

                      {
                        label: "Address (en)",
                        value: kycData.paciData.PersonalData?.Address?.DetailsEnglish,
                      },

                      {
                        label: "Address (ar)",
                        value: kycData.address?.DetailsArabic,
                      },
                      {
                        label: "PACI Address",
                        value: kycData.address_from_finder?.DetailsEnglish
                      },
                      // ...Object.keys(data?.address).map((key) => {return {label: key, value: data?.address[key]}} )
                    ]}
                  />
                  {kycData.photo && (
                    <ImageViewCard photo={kycData.photo} title="Photo" h={200} w="auto" />
                  )}
                  {kycData.signature && (
                    <ImageViewCard photo={kycData.signature} title="Signature" />
                  )}
                </SimpleGrid>
              </Box>
            </Collapse>
          </Paper>
        </>
      )}

      {/* Show photos from firebase storage */}
      <Space h="xl" />

      <Stack ta="start" gap="xl">
        {/* employee KYC files are HR only */}
        {customerData !== undefined && (!customerData.employee || userClaims.hr === true) && (
          <>
            <Title order={3}>Files</Title>
            <FilesList
              setMetaTypes={setMetaTypes}
              kycData={data}
              kycDocs={kycDocs}
              path={`kyc/${customerData.id}/`}
              setLinks={setLinks}
              links={links}
              onChange={() => {
                if (data) {
                  areAllFolderFilesTagged(`kyc/${customerData.id}/`, data.id).then((res) => {
                    setAllFilesTagged(res);
                  }).catch((err) => {
                    setAllFilesTagged(false);
                  });

                };

              }}
              customDocTypes={customDocTypes}
              showUploader={!disableUpload && customerData.tags?.kycStatus?.code !== "rejected"}
            />

          </>
        )}
        <Stack gap="md">
          <Grid gap="lg">
            {/* show actions taken on this KYC */}
            {(showButton ?? true) && (
              <Grid.Col span={{ base: 12, md: 6 }}>
                {renderProductTimeline}
              </Grid.Col>
            )}
            <Grid.Col span={{ base: 12, md: 6 }}>
              {/* Show product comments */}
              {kycRef ? renderProductComment : <Text>Loading comments...</Text>}
            </Grid.Col>
          </Grid>
          <Box mt="md" pt="md" style={{ borderTop: '1px solid var(--mantine-color-gray-3)' }} />
        </Stack>

        <MyUserDataContext.Consumer>
          {(userData: UserDataType) => (
            <ConfigContext.Consumer>
              {(config: any) => {
                //TODO: I think I need to refactor this into something more general
                //      since I'll most likely use it somewhere else.
                if (!data) return null;
                if (!config || !config.approvers) return null;
                let actionToTakeLabel: string | null = null;
                let actionToTake: ActionType | null = null;
                let actionColor = "";
                let state = data.state?.status_code;
                let approveButtonDisabled = false;
                let isApprover = false;
                let isExecApprover = false;
                let isKFHApprover = false;

                if (userClaims?.kfh_rm_approver) {
                  let kfhApprovers = config.approvers.kfh_approvers;

                  let isKFHApprover = kfhApprovers.includes(userData.user?.email ?? "");

                  if (!isKFHApprover) return null;

                  if (state === "selling_agent_review" || state === KYCStatusCode.selling_agent_update || state === KYCStatusCode.client_update) {
                    actionToTakeLabel = "Review";
                    actionToTake = "selling_agent_review";
                    actionColor = "teal";
                    if (data) {
                      areAllFolderFilesTagged(`kyc/${customerData.id}/`, data.id).then((res) => {
                        setAllFilesTagged(res);
                      }).catch((err) => {
                        setAllFilesTagged(false);
                      });
                    };
                  }

                }
                else {

                  const canReviewOrApprove = customerData.employee
                    ? !!(userClaims.hr || userClaims.cr)
                    : !!(userClaims.cr || userClaims.admin);
                  if (!canReviewOrApprove) return null;

                  if (
                    (!userData ||
                      !userData.msal ||
                      !(userData.msal.idTokenClaims as any).groups)
                  )
                    return null;

                  let groups = (userData.msal.idTokenClaims as any).groups;

                  //loop through all groups and see if they intersect.
                  let approvers = config.approvers.kyc_normal;
                  let execApprovers = config.approvers.kyc_executive;

                  isApprover = groups.some((group: string) =>
                    approvers.includes(group)
                  );
                  isExecApprover = groups.some((group: string) =>
                    execApprovers.includes(group)
                  );


                  // if (isApprover && data.approvedBy) return null;
                  // if (isExecApprover && data.approvedByExec) return null;

                  //loop backwards through actionsData and get the last actions that were after needs_update

                  //change buttons based on state

                  console.log("Buttons customer state: ", state);
                  if (KYCDoc && KYCDoc.exists() && (KYCDoc.data() as KYC).state?.status_code) {
                    state = (KYCDoc.data() as KYC).state?.status_code;
                    console.log("Buttons KYC ID: ", KYCDoc.id);
                    console.log("Buttons KYC state: ", state);
                  }



                  if (state === "review" || state === "selling_agent_review" || state === "client_update") {
                    actionToTakeLabel = "Review";
                    actionToTake = "review";
                    actionColor = "cyan";
                    if (data) {
                      areAllFolderFilesTagged(`kyc/${customerData.id}/`, data.id).then((res) => {
                        setAllFilesTagged(res);
                      }).catch((err) => {
                        setAllFilesTagged(false);
                      });
                    };
                  } else if (state === "approval" || state === "exec_approval") {
                    actionToTakeLabel = "Approve";
                    actionToTake = "approve";
                    actionColor = "green";
                  }

                  //make sure reviewer is not the same as approver

                  // CR may review (and reject) an employee KYC, only HR may approve it
                  if (actionToTake === "approve" && customerData.employee && !userClaims.hr) {
                    actionToTake = null;
                    actionToTakeLabel = null;
                  }

                  if (actionToTake === "approve") {
                    //loop through actionsAfterRejection
                    for (let i = 0; i < actionsAfterRejection.length; i++) {
                      if (actionsAfterRejection[i].id === userData.user?.uid) {
                        // approveButtonDisabled = true;
                        break;
                      }
                    }
                  }
                }


                if (showButton === false) {
                  return null;

                }

                const guardianBlock = (() => {
                  if (!data?.guardianKycID || !data?.guardianCustomerID) return null;

                  const gs = data.guardianKycState?.status_code;
                  if (!gs) return "Guardian KYC status not available yet.";

                  if (actionToTake === "review" && !["approval", "exec_approval", "valid"].includes(gs)) {
                    return `Guardian KYC must reach "approval" first (currently "${data.guardianKycState?.status ?? gs}").`;
                  }
                  if (actionToTake === "approve" && gs !== "valid") {
                    return `Guardian KYC must be "valid" first (currently "${data.guardianKycState?.status ?? gs}").`;
                  }
                  return null;
                })();
                return (
                  <Group>

                    {isEntityKycCustomer(customerData) &&
                      !data?.manual &&
                      !data?.paciData &&
                      state === "waiting_for_authorized_signatory" && (
                        <Button
                          color="blue"
                          type="button"
                          onClick={() => openSignatureLinkModal()}
                        >
                          Send Signature Link
                        </Button>
                      )}


                    {actionToTake && (
                      <Stack gap={4}>
                        <Button
                          disabled={!!guardianBlock || approveButtonDisabled || (actionToTake !== "selling_agent_review" && (cramMappingUnresolved || cramSnapshotMissing)) || cramProhibited || ((state === "review" || state === "selling_agent_review") && !allFilesTagged && !customerData.employee)}
                          color={actionColor}
                          type="button"
                          name="approve"
                          onClick={async () => {
                            setConfirmDialog({
                              title: "Confirm",
                              action: actionToTakeLabel,
                              description: `
                           
                            \n
                            ${actionToTakeLabel} ${data?.name_en ?? (data?.completedKYCData?.customerId)}'s KYC?`,
                              buttonColor: actionColor,
                              callback: async () => {
                                //The action needs Microzift's accessToken so I can verify groups from the server side.
                                //check if the user is kfh or kfhc and get token accordingly ?

                                let token = userClaims?.kfh_rm_approver ? "" : await userData.getAzureADToken!(
                                  userData
                                );

                                if (!token && !userClaims?.kfh_rm_approver) {
                                  throw new FirebaseError(
                                    "no_microsoft_token",
                                    "No Microsoft token.  Try refreshing"
                                  );
                                }

                                const res: any = await kycAction({
                                  action: actionToTake!,
                                  kycID: KYCDoc?.id,
                                  customerID: customerData?.id,
                                  token: token || "",
                                });
                                console.log(res);
                              },
                            });
                          }}
                        >
                          {actionToTakeLabel}
                        </Button>
                        {cramProhibited && (
                          <Text size="xs" c="red" maw={240}>
                            CRAM rated this customer <b>Prohibited</b>, so {actionToTakeLabel?.toLowerCase()} is blocked — the case must be rejected.
                            {cramProhibitedReasons.length > 0 && (
                              <> Reason{cramProhibitedReasons.length > 1 ? "s" : ""}: {cramProhibitedReasons.join("; ")}.</>
                            )}
                          </Text>
                        )}
                        {actionToTake !== "selling_agent_review" && cramSnapshotMissing && (
                          <Text size="xs" c="red" maw={240}>
                            No CRAM assessment was computed for this KYC, so {actionToTakeLabel?.toLowerCase()} is blocked. Recompute CRAM for this customer, then try again.
                          </Text>
                        )}
                        {actionToTake !== "selling_agent_review" && cramMappingUnresolved && (
                          <Text size="xs" c="orange" maw={240}>
                            Confirm or update the CRAM employment mapping above before you can {actionToTakeLabel?.toLowerCase()} this KYC.
                          </Text>
                        )}
                      </Stack>
                    )
                    }

                    {/* {
                      <>
                        {console.log(`SHOW REJECT BUTN  (state !== "rejected" && (isApprover || isExecApprover || isKFHApprover) `,)}
                        {console.log(` (state ====>) `, state)}
                        {console.log(` (isApprover ====>) `, isApprover)}
                        {console.log(` (isExecApprover ====>) `, isExecApprover)}
                        {console.log(` (isKFHApprover ====>) `, isKFHApprover)}
                      </>
                    } */}
                    {(state !== "rejected" && (isApprover || isExecApprover || userClaims?.kfh_rm_approver)) && (
                      <CustomRejectionModal
                        onSubmit={handleKYCRejection}
                        title="Reject KYC"
                        submitButtonText={(isApprover || userClaims?.kfh_rm_approver)
                          ? "Reject"
                          : isExecApprover
                            ? "Executive Rejection"
                            : "This button shouldn't exist "}
                        submitButtonColor="red"
                        triggerButtonText={(isApprover || userClaims?.kfh_rm_approver)
                          ? "Reject"
                          : isExecApprover
                            ? "Executive Rejection"
                            : "This button shouldn't exist "}
                        triggerButtonColor="red"
                        triggerButtonDisabled={false}
                        showSMSOptions={true}
                        showUpdateLinkOptions={true}
                        enableSendToAgent={(data?.require_selling_agent_review && (isApprover || isExecApprover))}
                        initialValues={{
                          linkInfo: {
                            senderID: "KFHC-KYC",
                            updateType: "none"
                          }
                        }}
                        kycData={data}
                        customer={customerData}
                      />
                    )}

                  </Group>
                );
              }}
            </ConfigContext.Consumer>
          )}
        </MyUserDataContext.Consumer >
      </Stack >
      <Space h="xl" />

      {kycRef && (
        <InterviewFormModal
          opened={interviewModalOpened}
          onClose={closeInterviewModal}
          kycRef={kycRef}
          signatories={enrichedSignatories}
          existing={data?.interviewFormData}
          customerData={customerData}
        />
      )}

      <PepModificationModal
        requireEditReason={true}
        politicalPositionOptions={politicalPositionOptions}
        initialPepPoliticalPositions={(kycData?.politicalPosition || []) as string[]}
        initialRelativePoliticalPositions={(kycData?.relativePoliticalPosition || []) as string[]}
        initialRelativePoliticalPositionInformation={kycData?.relativePoliticalPositionInformation || []}
        opened={!!pepModificationModalOpened}
        onClose={closePepModificationModal}
        onSubmit={async (values) => {
          const token = await userData.getAzureADToken!(userData);
          if (!token) {
            throw new Error("No Microsoft Token. Try refreshing.");
          }

          {



            const selectedPepPositions = values.pepPoliticalPositions as PoliticalPosition[];
            const selectedRelativePositions = values.relativePoliticalPositions as PoliticalPosition[];
            // CRAM reads a non-"None" politicallyExposedType as a PEP hit
            // (a direct high-risk factor), so a stale "Me" left behind after
            // the positions are cleared would keep the customer High.
            const nextPoliticallyExposedType = values.includePep
              ? PoliticallyExposedType.Me
              : values.includeRelative
                ? PoliticallyExposedType.Family
                : PoliticallyExposedType.None;
            const updatedDataEntry = {
              updated_by: userData.user?.email!,
              updated_on: Timestamp.now(),
              initial_value: [
                { politicalPosition: kycData?.politicalPosition ?? "" },
                { relativePoliticalPosition: kycData?.relativePoliticalPosition ?? "" },
                { relativePoliticalPositionInformation: kycData?.relativePoliticalPositionInformation ?? "" },
                { politicallyExposedType: kycData?.politicallyExposedType ?? "" },
              ],
              updated_fields: [
                { politicallyExposedType: nextPoliticallyExposedType },
                ...(values.includePep ? [{ politicalPosition: selectedPepPositions }] : [{ politicalPosition: "DELETED" }]),
                ...(values.includeRelative ? [{ relativePoliticalPosition: selectedRelativePositions }] : [{ relativePoliticalPosition: "DELETED" }]),
                ...(values.includeRelative
                  ? [{ relativePoliticalPositionInformation: [{ relation: values.relativeRelation, name: values.relativeName }] }]
                  : [{ relativePoliticalPositionInformation: "DELETED" }]),
              ],
              reason: values.editReason,
            };




            // await updateDoc(itemRef, updateditemData)
            try {

              await setDoc(kycRef!, {
                politicallyExposedType: nextPoliticallyExposedType,
                ...(values.includePep ? { politicalPosition: selectedPepPositions } : { politicalPosition: deleteField() }),
                ...(values.includeRelative ? { relativePoliticalPosition: selectedRelativePositions } : { relativePoliticalPosition: deleteField() }),
                ...(values.includeRelative
                  ? { relativePoliticalPositionInformation: [{ relation: values.relativeRelation, name: values.relativeName }] }
                  : { relativePoliticalPositionInformation: deleteField() }),
                updated_data: arrayUnion(updatedDataEntry as any)
              }, { merge: true });
              return {
                data: { status: "success" }
              }
            } catch (e) {
              throw (e)
            }

            // await addToHistory(kycRef, { msg: `AML risk override.` }, auth);

          }

          // const response = await screeningReview({
          //   customerID: customerID!,
          //   kycID: kycData?.id!,
          //   hitId: napierScreeningPepModal!.refDataId,
          //   token,
          //   status: NapierHitsClassification.true_match_pep,
          //   review: "AML screening result",
          //   pepType: values.pepType!,
          // });
          // return response;

        }}
      />

      <Modal
        opened={signatureLinkModalOpened}
        onClose={() => {
          closeSignatureLinkModal();
          setSignatureLinkError(null);
          setSelectedSignatoryId(null);
        }}
        title="Send Signature Link"
        size="md"
      >
        <Stack gap="sm">
          {signatureLinkError && <Alert color="red" icon={<IconAlertCircle size={16} />}>{signatureLinkError}</Alert>}

          <Select
            label="Authorized Signatory"
            placeholder="Select signatory"
            value={selectedSignatoryId}
            onChange={setSelectedSignatoryId}
            data={enrichedSignatories.map((s) => ({
              value: s.id,
              label: s.customer?.name_en ?? s.customer?.name_ar ?? s.id,
            }))}
          />
          <Group justify="flex-end" mt="sm">
            <Button variant="default" onClick={closeSignatureLinkModal} disabled={sendingSignatureLink}>Cancel</Button>
            <Button
              color="blue"
              loading={sendingSignatureLink}
              disabled={!selectedSignatoryId}
              onClick={handleSendSignatureLink}
            >
              Send
            </Button>
          </Group>
        </Stack>
      </Modal>

      {renderGeneratePDFModal}

      {renderPromotionalMaterialModal}
      {renderFamilyMemberModal}
      {/* <Row>
                <Col md="auto"> */}
      {
        msg != null && ( //love my check if it's an error or not.  Please don't do this, it's just a proof of concept page.
          <Alert color={isError ? "red" : "green"}>{msg}</Alert>
        )
      }
      {/* </Col>
            </Row> */}
    </>
  );
};


const GENDER_LABELS: Record<string, string> = {
  M: 'Male',
  F: 'Female',
};

interface MinorInfoCardProps {
  kyc: KYC;
  itemDoc?: QueryDocumentSnapshot<KYC>;
  updatedItemData: ItemInfoEditedObj<KYC>;
  title?: string;
  color?: string;
  cols?: number;
  /** Extra cards rendered in the same grid, sized like the info card (e.g. the minor's AML screening). */
  children?: React.ReactNode;
}


// Reusable MinorInfoCard
export function MinorInfoCard({
  kyc,
  itemDoc,
  updatedItemData,
  title = 'Client Information',
  color = 'blue',
  cols = 3,
  children,
}: MinorInfoCardProps) {

  const db = useFirestore();
  const [minorKyc, setMinorKyc] = useState<KYC | null>(null);

  const minorCustomerId = kyc?.completedKYCData?.customerId;

  const hasBeneficiaries = !!kyc?.beneficiaryInformation?.length || kyc.guardianCustomerID;

  useEffect(() => {
    if (!hasBeneficiaries || !minorCustomerId || !kyc?.id) {
      setMinorKyc(null);
      return;
    }
    const ref = doc(db, "customers", minorCustomerId, "kyc", kyc.id);
    return onSnapshot(ref, (snap) => {
      setMinorKyc(snap.exists() ? ({ id: snap.id, ...snap.data() } as KYC) : null);
    });
  }, [db, minorCustomerId, kyc?.id, hasBeneficiaries]);

  const kycData = minorKyc ?? kyc;

  if (kyc?.beneficiaryInformation && !minorKyc) return null;

  if (!kycData) return null;

  const field = (k: KYC, key: string): string | undefined => {
    const v = (k as unknown as Record<string, unknown>)[key];
    // Firestore Timestamp has .toDate(); also handle Date and epoch millis
    if (v && typeof (v as any).toDate === 'function') {
      return (v as any).toDate().toLocaleDateString('en-GB');
    }
    if (v instanceof Date) return v.toLocaleDateString('en-GB');
    return typeof v === 'string' || typeof v === 'number' ? String(v) : undefined;
  };

  return (
    <SimpleGrid cols={cols}>
      <EditableInfoCard<KYC>
        title={title}
        color={color}
        icon={<IconPhone size={16} />}
        itemDoc={itemDoc}
        updatedItemData={updatedItemData}
        list={[
          { label: 'Name (AR)', value: field(kycData, 'name_ar') },
          { label: 'Name (EN)', value: field(kycData, 'name_en') },
          { label: 'Customer Id', value: field(kycData, 'customerID') ?? kycData.completedKYCData?.customerId },
          { label: 'Civil ID', value: field(kycData, 'civilID') ?? kycData.completedKYCData?.civilID },
          { label: 'Gender', value: GENDER_LABELS[field(kycData, 'gender') ?? ''] ?? '—' },
          { label: 'Birth Date', value: field(kycData, 'birthDate') },
          { label: 'CivilIDExpiryDate', value: field(kycData, 'civilIDExpiryDate') },
          { label: 'Nationality', value: field(kycData, 'nationality') },
          { label: 'Place Of Birth', value: field(kycData, 'placeOfBirth') },
          { label: 'residence', value: field(kycData, 'residence') },
        ]}
      />
      {children}
    </SimpleGrid>
  );
}
